var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorysetStandOut31397(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-stand-out",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-stand-out:not(.animated) .animable {opacity: 0;}svg#freepik_stories-stand-out.animated #freepik--Sunburst--inject-8 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}svg#freepik_stories-stand-out.animated #freepik--Plants--inject-8 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-stand-out.animated #freepik--character-1--inject-8 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;} @keyframes wind {0 % { transform: rotate(0deg );}                25% {transform: rotate( 1deg );}                75% {transform: rotate( -1deg );}} @keyframes floating {0 % { opacity: 1;                    transform: translateY(0px);}                50% {transform: translateY(-10px);}                100% {opacity: 1;                    transform: translateY(0px);}} @keyframes\n        zoomOut {0 % { opacity: 0;                    transform: scale(1.5);}                100% {opacity: 1;                    transform: scale(1);}}        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-8",
    className: "animable",
    style: {
      transformOrigin: "249.998px 355.163px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-8",
    d: "M77.67,454.67c-95.18-54.95-95.18-144,0-199s249.49-54.94,344.66,0,95.18,144.05,0,199S172.84,509.62,77.67,454.67Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "249.998px 355.163px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sunburst--inject-8",
    className: "animable",
    style: {
      transformOrigin: "250px 176.615px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-8",
    className: "animable",
    style: {
      transformOrigin: "250px 176.615px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.35,176.62c-1.57-3.53-1.69-7.05-1.69-10.57l-.12-10.58c-.12-7.05-.08-14.09-.08-21.14.07-14.1.29-28.2.49-42.29s.43-28.2.75-42.3l.5-21.14c.21-7,.38-14.1.64-21.15h.32c.26,7.05.43,14.1.64,21.15l.5,21.14c.32,14.1.49,28.2.75,42.3s.42,28.19.49,42.29c0,7,0,14.09-.08,21.14l-.12,10.58c0,3.52-.12,7-1.69,10.57Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "249.997px 92.035px"
    },
    id: "el0jmnai4gnlt6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,176.73c-2.16-3.2-2.89-6.65-3.5-10.12l-2-10.39c-1.34-6.92-2.52-13.87-3.74-20.81-2.38-13.89-4.61-27.82-6.86-41.73s-4.48-27.84-6.61-41.78L223.5,31c-1-7-2.06-13.95-3-20.94l.31-.05c1.48,6.89,2.87,13.8,4.31,20.71l4.16,20.74C232,65.27,234.63,79.13,237.33,93s5.31,27.69,7.83,41.56c1.22,6.94,2.49,13.87,3.59,20.84l1.72,10.43c.61,3.47,1.1,7,.17,10.71Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "235.829px 93.37px"
    },
    id: "el3giysbxipsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.39,176.84c-2.68-2.78-4-6-5.21-9.36l-3.73-9.89c-2.52-6.58-4.89-13.22-7.3-19.84-4.76-13.28-9.37-26.6-14-39.91s-9.24-26.64-13.76-40l-6.77-20c-2.21-6.7-4.46-13.38-6.63-20.09l.3-.11c2.66,6.53,5.23,13.1,7.84,19.65l7.7,19.7C213,70.09,217.93,83.28,223,96.44s10,26.35,14.93,39.57c2.41,6.62,4.87,13.23,7.16,19.89l3.5,10c1.21,3.31,2.3,6.67,2,10.52Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "221.315px 97.24px"
    },
    id: "elytc3f6qxk6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.44,176.94c-3.12-2.27-5-5.26-6.75-8.31l-5.4-9.09c-3.63-6-7.11-12.17-10.63-18.28-7-12.24-13.85-24.56-20.72-36.87s-13.73-24.63-20.5-37L175.29,48.83c-3.33-6.21-6.71-12.4-10-18.64l.27-.15c3.75,6,7.42,12,11.14,18l11,18.06c7.32,12,14.52,24.17,21.79,36.25s14.46,24.21,21.57,36.38c3.53,6.11,7.09,12.19,10.51,18.35l5.18,9.22c1.76,3.05,3.42,6.17,3.82,10Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "207.93px 103.49px"
    },
    id: "elfnwe62mwvz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51,177c-3.47-1.69-5.83-4.31-8.1-7l-6.89-8c-4.62-5.32-9.12-10.75-13.65-16.15-9-10.84-17.9-21.78-26.81-32.71s-17.79-21.87-26.61-32.88L154.24,63.75c-4.37-5.54-8.77-11-13.1-16.62l.24-.2c4.73,5.23,9.39,10.52,14.09,15.78l14,15.88c9.31,10.59,18.5,21.28,27.76,31.92s18.45,21.33,27.56,32.08c4.53,5.4,9.1,10.77,13.54,16.25L245,167c2.26,2.7,4.43,5.48,5.49,9.19Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "195.815px 111.965px"
    },
    id: "elb0bsw3a3yds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.58,177.11c-3.71-1.06-6.48-3.23-9.18-5.5l-8.18-6.7c-5.48-4.43-10.85-9-16.25-13.53-10.75-9.12-21.41-18.35-32.08-27.56S162.57,105.37,152,96.06l-15.88-14c-5.26-4.7-10.55-9.36-15.78-14.09l.2-.24c5.57,4.33,11.08,8.73,16.62,13.1l16.51,13.21c11,8.82,21.92,17.75,32.88,26.61s21.87,17.8,32.71,26.81c5.4,4.53,10.83,9,16.16,13.65l8,6.89c2.7,2.26,5.32,4.62,7,8.09Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "185.38px 122.42px"
    },
    id: "elrypkpv2yze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68,177.18c-3.84-.4-7-2.06-10-3.82l-9.21-5.18c-6.17-3.42-12.25-7-18.35-10.51-12.18-7.11-24.28-14.35-36.38-21.57s-24.21-14.47-36.26-21.79l-18.06-11c-6-3.72-12-7.39-18-11.14l.16-.27c6.23,3.3,12.42,6.68,18.63,10l18.56,10.15c12.37,6.77,24.67,13.67,37,20.5s24.63,13.73,36.87,20.71c6.11,3.53,12.24,7,18.28,10.64L242,169.3c3.06,1.77,6.05,3.64,8.31,6.76Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "176.865px 134.54px"
    },
    id: "el0myfv67bj51",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.78,177.23c-3.85.27-7.2-.82-10.52-2l-10-3.5c-6.67-2.3-13.28-4.75-19.9-7.16-13.22-4.89-26.39-9.92-39.57-14.93s-26.35-10-39.49-15.17l-19.7-7.69c-6.55-2.62-13.11-5.19-19.65-7.84l.11-.3c6.71,2.17,13.39,4.42,20.09,6.63l20,6.76c13.36,4.52,26.66,9.18,40,13.77s26.64,9.24,39.91,14c6.62,2.41,13.26,4.78,19.84,7.3l9.9,3.73c3.31,1.21,6.58,2.53,9.35,5.21Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "170.55px 147.956px"
    },
    id: "elcmkzsr448gt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89,177.25c-3.75.94-7.24.45-10.71-.16l-10.43-1.72c-7-1.1-13.9-2.37-20.84-3.6-13.87-2.51-27.72-5.18-41.56-7.83s-27.7-5.31-41.52-8.07l-20.74-4.16c-6.9-1.44-13.82-2.83-20.71-4.31l.05-.31c7,1,14,2,20.94,3l20.91,3.19c13.94,2.13,27.85,4.41,41.78,6.61s27.84,4.48,41.73,6.85c6.94,1.23,13.89,2.41,20.81,3.75l10.39,2c3.48.61,6.92,1.34,10.12,3.5Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "166.745px 162.433px"
    },
    id: "ely9urhw0yli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,177.26c-3.52,1.58-7.05,1.7-10.57,1.7l-10.58.12c-7,.12-14.09.08-21.14.08-14.1-.07-28.2-.29-42.29-.5s-28.2-.42-42.29-.74l-21.15-.5c-7-.21-14.1-.38-21.15-.65v-.31c7-.26,14.1-.43,21.15-.65l21.15-.49c14.09-.32,28.19-.49,42.29-.75s28.19-.42,42.29-.49c7,0,14.1-.05,21.14.07l10.58.13c3.52,0,7,.12,10.57,1.69Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "165.415px 176.618px"
    },
    id: "eljw34ye7bfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,177.25c-3.2,2.16-6.64,2.9-10.12,3.51l-10.39,2c-6.92,1.34-13.87,2.52-20.81,3.74-13.89,2.38-27.81,4.61-41.73,6.86s-27.84,4.48-41.78,6.61l-20.91,3.18c-7,1-14,2.07-20.94,3l-.05-.31c6.89-1.48,13.81-2.87,20.71-4.31l20.74-4.16c13.82-2.76,27.68-5.38,41.52-8.08S194,184,207.91,181.46c6.94-1.22,13.88-2.49,20.84-3.6l10.43-1.71c3.47-.61,7-1.1,10.71-.17Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "166.745px 190.806px"
    },
    id: "ely5et6as3l1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22,177.23c-2.77,2.68-6,4-9.35,5.2l-9.9,3.74c-6.58,2.52-13.22,4.89-19.84,7.3-13.27,4.75-26.6,9.37-39.91,14s-26.64,9.24-40,13.76l-20,6.77c-6.7,2.21-13.38,4.46-20.09,6.62l-.11-.29c6.54-2.66,13.1-5.23,19.65-7.84l19.7-7.7c13.14-5.12,26.33-10.1,39.49-15.16s26.35-10,39.57-14.93c6.62-2.41,13.23-4.87,19.9-7.16l10-3.51c3.32-1.2,6.67-2.29,10.52-2Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "170.62px 205.301px"
    },
    id: "elwyuk61h6o8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32,177.18c-2.26,3.12-5.25,5-8.31,6.75l-9.09,5.39c-6,3.63-12.17,7.12-18.28,10.64-12.24,7-24.56,13.85-36.87,20.72s-24.63,13.73-37,20.5l-18.56,10.14c-6.21,3.34-12.4,6.72-18.63,10l-.16-.27c6-3.76,12-7.43,18-11.14l18.06-11c12.05-7.33,24.18-14.52,36.26-21.79s24.2-14.47,36.38-21.57c6.1-3.53,12.18-7.09,18.35-10.51l9.21-5.18c3.06-1.77,6.17-3.42,10-3.82Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "176.87px 218.68px"
    },
    id: "elmti55tlv9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41,177.11c-1.68,3.47-4.3,5.83-7,8.1l-8,6.89c-5.33,4.62-10.76,9.12-16.16,13.65-10.84,9-21.78,17.9-32.71,26.8s-21.87,17.8-32.88,26.62l-16.51,13.21c-5.54,4.36-11,8.77-16.62,13.1l-.2-.24c5.23-4.74,10.52-9.4,15.78-14.09l15.88-14c10.6-9.31,21.29-18.5,31.92-27.76S205.22,211,216,201.86c5.4-4.53,10.77-9.1,16.25-13.54l8.18-6.7c2.7-2.26,5.47-4.44,9.18-5.5Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "185.37px 230.8px"
    },
    id: "el35j4fbf18dv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49,177c-1.06,3.71-3.23,6.49-5.49,9.19l-6.7,8.18c-4.44,5.48-9,10.85-13.54,16.25-9.11,10.75-18.35,21.41-27.56,32.08s-18.45,21.32-27.76,31.91l-14,15.89c-4.7,5.25-9.36,10.55-14.09,15.78l-.24-.2c4.33-5.57,8.73-11.08,13.1-16.62L167.45,273c8.82-11,17.75-21.91,26.61-32.87s17.8-21.87,26.81-32.72c4.53-5.4,9-10.83,13.65-16.15l6.89-8c2.27-2.7,4.63-5.32,8.1-7Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "195.8px 241.27px"
    },
    id: "el8vyutcng005",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56,176.94c-.4,3.84-2.06,6.95-3.82,10l-5.18,9.22c-3.42,6.17-7,12.25-10.51,18.35-7.11,12.18-14.35,24.27-21.57,36.38S195,275.1,187.69,287.14l-11,18.07c-3.72,6-7.39,12-11.14,18l-.27-.16c3.3-6.23,6.68-12.42,10-18.64l10.15-18.55c6.77-12.37,13.67-24.67,20.5-37s13.73-24.63,20.72-36.88c3.52-6.1,7-12.23,10.63-18.27l5.4-9.1c1.76-3,3.63-6,6.75-8.3Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "207.92px 249.76px"
    },
    id: "elf391xrcewhd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.61,176.84c.27,3.85-.82,7.2-2,10.51l-3.5,10c-2.29,6.67-4.75,13.27-7.16,19.9C233,230.45,228,243.62,223,256.8s-10,26.35-15.16,39.48L200.13,316c-2.61,6.55-5.18,13.11-7.84,19.65l-.3-.11c2.17-6.72,4.42-13.4,6.63-20.09l6.77-20c4.52-13.36,9.18-26.67,13.76-40s9.24-26.64,14-39.91c2.41-6.62,4.78-13.26,7.3-19.84l3.73-9.9c1.21-3.31,2.53-6.58,5.21-9.35Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "221.321px 256.05px"
    },
    id: "elxfogzxf7u2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.64,176.73c.93,3.74.44,7.24-.17,10.71l-1.72,10.43c-1.1,7-2.37,13.9-3.59,20.84-2.52,13.87-5.19,27.71-7.83,41.56S232,288,229.25,301.79l-4.16,20.74c-1.44,6.9-2.83,13.82-4.31,20.71l-.31-.05c1-7,2-14,3-20.94l3.19-20.91c2.13-13.94,4.41-27.85,6.61-41.78s4.48-27.84,6.86-41.73c1.22-7,2.4-13.89,3.74-20.82l2-10.39c.61-3.47,1.34-6.92,3.5-10.11Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "235.814px 259.875px"
    },
    id: "elukl011fbfej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.65,176.62c1.57,3.52,1.69,7,1.69,10.57l.12,10.57c.12,7.05.08,14.1.08,21.15-.07,14.1-.29,28.19-.49,42.29s-.43,28.2-.75,42.29l-.5,21.15c-.21,7.05-.38,14.1-.64,21.14h-.32c-.26-7-.43-14.09-.64-21.14l-.5-21.15c-.32-14.09-.49-28.19-.75-42.29s-.42-28.19-.49-42.29c0-7,0-14.1.08-21.15l.12-10.57c0-3.52.12-7.05,1.69-10.57Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "250.003px 261.2px"
    },
    id: "ellakuuwzk2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.64,176.51c2.16,3.19,2.89,6.64,3.5,10.11l2,10.39c1.34,6.93,2.52,13.87,3.74,20.82,2.38,13.89,4.61,27.81,6.86,41.73s4.48,27.84,6.61,41.78l3.19,20.91c1,7,2.06,13.95,3,20.94l-.31.05c-1.48-6.89-2.87-13.81-4.31-20.71l-4.16-20.74c-2.76-13.83-5.38-27.68-8.08-41.52s-5.31-27.69-7.83-41.56c-1.22-6.94-2.49-13.88-3.59-20.84l-1.72-10.43c-.61-3.47-1.1-7-.17-10.71Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "264.196px 259.875px"
    },
    id: "eloc53ux3gf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.61,176.4c2.68,2.77,4,6,5.21,9.35l3.73,9.9c2.52,6.58,4.89,13.22,7.3,19.84,4.76,13.27,9.37,26.59,14,39.91s9.24,26.64,13.76,40l6.77,20c2.21,6.69,4.46,13.37,6.63,20.09l-.3.11c-2.66-6.54-5.23-13.1-7.84-19.65l-7.7-19.71C287.05,283.15,282.07,270,277,256.8s-10-26.35-14.93-39.57c-2.41-6.63-4.87-13.23-7.16-19.9l-3.5-10c-1.21-3.31-2.3-6.66-2-10.51Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "278.685px 256px"
    },
    id: "elwloi6bjcl4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56,176.3c3.12,2.26,5,5.25,6.75,8.3l5.4,9.1c3.63,6,7.11,12.17,10.63,18.27,7,12.25,13.85,24.57,20.72,36.88s13.73,24.63,20.5,37l10.15,18.55c3.33,6.22,6.71,12.41,10,18.64l-.27.16c-3.75-6-7.42-12-11.14-18l-11-18.07c-7.32-12-14.52-24.17-21.79-36.25s-14.46-24.2-21.57-36.38c-3.53-6.1-7.09-12.18-10.51-18.35l-5.18-9.22c-1.76-3.05-3.42-6.16-3.82-10Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "292.07px 249.75px"
    },
    id: "elnv8d544o3oj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49,176.2c3.47,1.69,5.83,4.31,8.1,7l6.89,8c4.62,5.32,9.12,10.75,13.65,16.15,9,10.85,17.9,21.79,26.81,32.72S323.73,262,332.55,273l13.21,16.52c4.37,5.54,8.77,11.05,13.1,16.62l-.24.2c-4.73-5.23-9.39-10.53-14.09-15.78l-14-15.89c-9.31-10.59-18.5-21.28-27.76-31.91s-18.45-21.33-27.56-32.08c-4.53-5.4-9.1-10.77-13.54-16.25l-6.7-8.18c-2.26-2.7-4.43-5.48-5.49-9.19Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "304.17px 241.27px"
    },
    id: "elop3llklqib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41,176.12c3.72,1.06,6.49,3.24,9.19,5.5l8.18,6.7c5.48,4.44,10.85,9,16.25,13.54,10.75,9.11,21.41,18.34,32.08,27.56s21.32,18.45,31.92,27.76l15.88,14c5.26,4.69,10.55,9.35,15.78,14.09l-.2.24c-5.57-4.33-11.08-8.74-16.62-13.1l-16.51-13.21c-11-8.82-21.92-17.75-32.88-26.62s-21.87-17.79-32.71-26.8c-5.4-4.53-10.83-9-16.16-13.65l-8-6.89c-2.7-2.27-5.32-4.63-7-8.1Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "314.65px 230.815px"
    },
    id: "elql44l5w8ujq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32,176.06c3.84.4,6.95,2.05,10,3.82l9.21,5.18c6.17,3.42,12.25,7,18.35,10.51,12.18,7.1,24.28,14.34,36.38,21.57s24.21,14.46,36.26,21.79l18.06,11c6,3.71,12,7.38,18,11.14l-.16.27c-6.23-3.3-12.42-6.68-18.63-10l-18.56-10.14c-12.37-6.77-24.67-13.67-37-20.5S297.6,207,285.36,200c-6.11-3.52-12.24-7-18.28-10.64L258,183.93c-3.06-1.76-6.05-3.63-8.31-6.75Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "323.135px 218.7px"
    },
    id: "elobhcv69jsse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22,176c3.85-.27,7.2.82,10.52,2l10,3.51c6.67,2.29,13.28,4.75,19.9,7.16,13.22,4.88,26.39,9.91,39.57,14.93s26.35,10,39.49,15.16l19.7,7.7c6.55,2.61,13.11,5.18,19.65,7.84l-.11.29c-6.71-2.16-13.39-4.41-20.09-6.62l-20-6.77c-13.36-4.52-26.66-9.18-40-13.76s-26.64-9.25-39.91-14c-6.62-2.41-13.26-4.78-19.84-7.3l-9.9-3.74c-3.31-1.2-6.58-2.52-9.35-5.2Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "329.45px 205.274px"
    },
    id: "elk1hbqfifv8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,176c3.75-.93,7.24-.44,10.71.17l10.43,1.71c7,1.11,13.9,2.38,20.84,3.6,13.87,2.52,27.72,5.18,41.56,7.83s27.69,5.32,41.52,8.08l20.74,4.16c6.9,1.44,13.82,2.83,20.71,4.31l-.05.31c-7-1-14-2-20.94-3l-20.91-3.18c-13.94-2.13-27.85-4.41-41.78-6.61s-27.84-4.48-41.73-6.86c-6.94-1.22-13.89-2.4-20.81-3.74l-10.39-2c-3.48-.61-6.92-1.35-10.12-3.51Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "333.255px 190.826px"
    },
    id: "eldmomhycp90d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,176c3.52-1.57,7.05-1.69,10.57-1.69l10.58-.13c7-.12,14.09-.07,21.14-.07,14.1.07,28.2.29,42.29.49s28.2.43,42.29.75l21.15.49c7.05.22,14.1.39,21.15.65v.31c-7.05.27-14.1.44-21.15.65l-21.15.5c-14.09.32-28.19.49-42.29.74s-28.19.43-42.29.5c-7.05,0-14.1,0-21.14-.08L260.57,179c-3.52,0-7-.12-10.57-1.7Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "334.585px 176.645px"
    },
    id: "elzcfar855bpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89,176c3.2-2.16,6.64-2.89,10.12-3.5l10.39-2c6.92-1.34,13.87-2.52,20.81-3.75,13.89-2.37,27.81-4.61,41.73-6.85s27.84-4.48,41.78-6.61l20.91-3.19c7-1,13.95-2.07,20.94-3l.05.31c-6.89,1.48-13.81,2.87-20.71,4.31l-20.74,4.16c-13.83,2.76-27.68,5.38-41.52,8.07s-27.69,5.32-41.56,7.83c-6.94,1.23-13.88,2.5-20.84,3.6l-10.43,1.72c-3.47.61-7,1.1-10.71.16Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "333.255px 162.443px"
    },
    id: "elsas38sx8h1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.78,176c2.77-2.68,6-4,9.35-5.21l9.9-3.73c6.58-2.52,13.22-4.89,19.84-7.3,13.27-4.76,26.6-9.37,39.91-14s26.64-9.25,40-13.77l20-6.76c6.7-2.21,13.38-4.46,20.09-6.63l.11.3c-6.54,2.65-13.1,5.22-19.65,7.84l-19.7,7.69c-13.14,5.13-26.33,10.11-39.49,15.17s-26.35,10-39.57,14.93c-6.62,2.41-13.23,4.86-19.9,7.16l-10,3.5c-3.32,1.21-6.67,2.3-10.52,2Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "329.38px 147.92px"
    },
    id: "el2x43of0club",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68,176.06c2.26-3.12,5.25-5,8.31-6.76l9.09-5.39c6-3.63,12.17-7.11,18.28-10.64,12.24-7,24.56-13.84,36.87-20.71s24.63-13.73,37-20.5l18.56-10.15c6.21-3.33,12.4-6.71,18.63-10l.16.27c-6,3.75-12,7.42-18,11.14l-18.06,11c-12,7.32-24.18,14.52-36.26,21.79s-24.2,14.46-36.38,21.57c-6.1,3.52-12.18,7.09-18.35,10.51l-9.21,5.18c-3.06,1.76-6.17,3.42-10,3.82Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "323.13px 134.55px"
    },
    id: "elramq5xu3pj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.58,176.12c1.69-3.47,4.31-5.83,7-8.09l8-6.89c5.33-4.62,10.76-9.12,16.16-13.65,10.84-9,21.78-17.9,32.71-26.81s21.87-17.79,32.88-26.61l16.51-13.21c5.54-4.37,11.05-8.77,16.62-13.1l.2.24c-5.23,4.73-10.52,9.39-15.78,14.09L348,96.06c-10.6,9.31-21.29,18.5-31.92,27.76S294.78,142.26,284,151.38c-5.4,4.53-10.77,9.1-16.25,13.53l-8.18,6.7c-2.7,2.27-5.47,4.44-9.19,5.5Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "314.62px 122.435px"
    },
    id: "elzjuz8oseq4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51,176.2c1.06-3.71,3.23-6.49,5.49-9.19l6.7-8.17c4.44-5.48,9-10.85,13.54-16.25,9.11-10.75,18.34-21.41,27.56-32.08s18.45-21.33,27.76-31.92l14-15.88c4.7-5.26,9.36-10.55,14.09-15.78l.24.2c-4.33,5.57-8.73,11.08-13.1,16.62L332.55,80.26c-8.82,11-17.75,21.92-26.61,32.88s-17.8,21.87-26.81,32.71c-4.53,5.4-9,10.83-13.65,16.15l-6.89,8c-2.27,2.7-4.63,5.32-8.1,7Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "304.2px 111.965px"
    },
    id: "el6suh3z7bcnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.44,176.3c.4-3.84,2.06-7,3.82-10l5.18-9.22c3.42-6.16,7-12.24,10.51-18.35,7.11-12.17,14.35-24.27,21.57-36.38S305,78.14,312.31,66.09l11-18.06c3.72-6,7.39-12,11.14-18l.27.15c-3.3,6.24-6.68,12.43-10,18.64L314.56,67.39c-6.77,12.37-13.67,24.66-20.5,37S280.33,129,273.34,141.26c-3.52,6.11-7,12.23-10.63,18.28l-5.4,9.09c-1.76,3.05-3.63,6-6.75,8.31Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "292.08px 103.485px"
    },
    id: "elfoekqg75tgo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.39,176.4c-.27-3.85.82-7.21,2-10.52l3.5-10c2.29-6.66,4.75-13.27,7.16-19.89C267,122.79,272,109.61,277,96.44s10-26.35,15.16-39.49l7.7-19.7c2.61-6.55,5.18-13.12,7.84-19.65l.3.11c-2.17,6.71-4.42,13.39-6.63,20.09l-6.77,20c-4.52,13.36-9.18,26.66-13.76,40s-9.24,26.63-14,39.91c-2.41,6.62-4.78,13.26-7.3,19.84l-3.73,9.89c-1.21,3.32-2.53,6.58-5.21,9.36Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "278.674px 97.2px"
    },
    id: "elfc2omefr6of",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,176.51c-.93-3.75-.44-7.24.17-10.71l1.72-10.43c1.1-7,2.37-13.9,3.59-20.84,2.52-13.87,5.19-27.72,7.83-41.56s5.32-27.7,8.08-41.52l4.16-20.74c1.44-6.91,2.83-13.82,4.31-20.71l.31.05c-1,7-2,14-3,20.94L273.31,51.9c-2.13,13.94-4.41,27.85-6.61,41.78s-4.48,27.84-6.86,41.73c-1.22,6.94-2.4,13.89-3.74,20.81l-2,10.39c-.61,3.47-1.34,6.92-3.5,10.12Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "264.186px 93.365px"
    },
    id: "elzdv68ojv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el67r2t6nv0ig"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75,
      transformOrigin: "250px 176.615px"
    },
    className: "animable",
    id: "elj2z81ho2wmn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.35,176.62c-1.57-3.53-1.69-7.05-1.69-10.57l-.12-10.58c-.12-7.05-.08-14.09-.08-21.14.07-14.1.29-28.2.49-42.29s.43-28.2.75-42.3l.5-21.14c.21-7,.38-14.1.64-21.15h.32c.26,7.05.43,14.1.64,21.15l.5,21.14c.32,14.1.49,28.2.75,42.3s.42,28.19.49,42.29c0,7,0,14.09-.08,21.14l-.12,10.58c0,3.52-.12,7-1.69,10.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "249.997px 92.035px"
    },
    id: "el1nxiz43c4yq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,176.73c-2.16-3.2-2.89-6.65-3.5-10.12l-2-10.39c-1.34-6.92-2.52-13.87-3.74-20.81-2.38-13.89-4.61-27.82-6.86-41.73s-4.48-27.84-6.61-41.78L223.5,31c-1-7-2.06-13.95-3-20.94l.31-.05c1.48,6.89,2.87,13.8,4.31,20.71l4.16,20.74C232,65.27,234.63,79.13,237.33,93s5.31,27.69,7.83,41.56c1.22,6.94,2.49,13.87,3.59,20.84l1.72,10.43c.61,3.47,1.1,7,.17,10.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "235.829px 93.37px"
    },
    id: "el7944algjmbe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.39,176.84c-2.68-2.78-4-6-5.21-9.36l-3.73-9.89c-2.52-6.58-4.89-13.22-7.3-19.84-4.76-13.28-9.37-26.6-14-39.91s-9.24-26.64-13.76-40l-6.77-20c-2.21-6.7-4.46-13.38-6.63-20.09l.3-.11c2.66,6.53,5.23,13.1,7.84,19.65l7.7,19.7C213,70.09,217.93,83.28,223,96.44s10,26.35,14.93,39.57c2.41,6.62,4.87,13.23,7.16,19.89l3.5,10c1.21,3.31,2.3,6.67,2,10.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "221.315px 97.24px"
    },
    id: "elj9sk2q9pbn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.44,176.94c-3.12-2.27-5-5.26-6.75-8.31l-5.4-9.09c-3.63-6-7.11-12.17-10.63-18.28-7-12.24-13.85-24.56-20.72-36.87s-13.73-24.63-20.5-37L175.29,48.83c-3.33-6.21-6.71-12.4-10-18.64l.27-.15c3.75,6,7.42,12,11.14,18l11,18.06c7.32,12,14.52,24.17,21.79,36.25s14.46,24.21,21.57,36.38c3.53,6.11,7.09,12.19,10.51,18.35l5.18,9.22c1.76,3.05,3.42,6.17,3.82,10Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "207.93px 103.49px"
    },
    id: "el0hkjffgzcpp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51,177c-3.47-1.69-5.83-4.31-8.1-7l-6.89-8c-4.62-5.32-9.12-10.75-13.65-16.15-9-10.84-17.9-21.78-26.81-32.71s-17.79-21.87-26.61-32.88L154.24,63.75c-4.37-5.54-8.77-11-13.1-16.62l.24-.2c4.73,5.23,9.39,10.52,14.09,15.78l14,15.88c9.31,10.59,18.5,21.28,27.76,31.92s18.45,21.33,27.56,32.08c4.53,5.4,9.1,10.77,13.54,16.25L245,167c2.26,2.7,4.43,5.48,5.49,9.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "195.815px 111.965px"
    },
    id: "elsge5u27fnbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.58,177.11c-3.71-1.06-6.48-3.23-9.18-5.5l-8.18-6.7c-5.48-4.43-10.85-9-16.25-13.53-10.75-9.12-21.41-18.35-32.08-27.56S162.57,105.37,152,96.06l-15.88-14c-5.26-4.7-10.55-9.36-15.78-14.09l.2-.24c5.57,4.33,11.08,8.73,16.62,13.1l16.51,13.21c11,8.82,21.92,17.75,32.88,26.61s21.87,17.8,32.71,26.81c5.4,4.53,10.83,9,16.16,13.65l8,6.89c2.7,2.26,5.32,4.62,7,8.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "185.38px 122.42px"
    },
    id: "elxlng0gfe9zf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68,177.18c-3.84-.4-7-2.06-10-3.82l-9.21-5.18c-6.17-3.42-12.25-7-18.35-10.51-12.18-7.11-24.28-14.35-36.38-21.57s-24.21-14.47-36.26-21.79l-18.06-11c-6-3.72-12-7.39-18-11.14l.16-.27c6.23,3.3,12.42,6.68,18.63,10l18.56,10.15c12.37,6.77,24.67,13.67,37,20.5s24.63,13.73,36.87,20.71c6.11,3.53,12.24,7,18.28,10.64L242,169.3c3.06,1.77,6.05,3.64,8.31,6.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "176.865px 134.54px"
    },
    id: "elaxsnayzhqgk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.78,177.23c-3.85.27-7.2-.82-10.52-2l-10-3.5c-6.67-2.3-13.28-4.75-19.9-7.16-13.22-4.89-26.39-9.92-39.57-14.93s-26.35-10-39.49-15.17l-19.7-7.69c-6.55-2.62-13.11-5.19-19.65-7.84l.11-.3c6.71,2.17,13.39,4.42,20.09,6.63l20,6.76c13.36,4.52,26.66,9.18,40,13.77s26.64,9.24,39.91,14c6.62,2.41,13.26,4.78,19.84,7.3l9.9,3.73c3.31,1.21,6.58,2.53,9.35,5.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "170.55px 147.956px"
    },
    id: "el3hyqo8qq3hl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89,177.25c-3.75.94-7.24.45-10.71-.16l-10.43-1.72c-7-1.1-13.9-2.37-20.84-3.6-13.87-2.51-27.72-5.18-41.56-7.83s-27.7-5.31-41.52-8.07l-20.74-4.16c-6.9-1.44-13.82-2.83-20.71-4.31l.05-.31c7,1,14,2,20.94,3l20.91,3.19c13.94,2.13,27.85,4.41,41.78,6.61s27.84,4.48,41.73,6.85c6.94,1.23,13.89,2.41,20.81,3.75l10.39,2c3.48.61,6.92,1.34,10.12,3.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "166.745px 162.433px"
    },
    id: "elp94jvjk7ibp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,177.26c-3.52,1.58-7.05,1.7-10.57,1.7l-10.58.12c-7,.12-14.09.08-21.14.08-14.1-.07-28.2-.29-42.29-.5s-28.2-.42-42.29-.74l-21.15-.5c-7-.21-14.1-.38-21.15-.65v-.31c7-.26,14.1-.43,21.15-.65l21.15-.49c14.09-.32,28.19-.49,42.29-.75s28.19-.42,42.29-.49c7,0,14.1-.05,21.14.07l10.58.13c3.52,0,7,.12,10.57,1.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "165.415px 176.618px"
    },
    id: "el8f3nyrdcvai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,177.25c-3.2,2.16-6.64,2.9-10.12,3.51l-10.39,2c-6.92,1.34-13.87,2.52-20.81,3.74-13.89,2.38-27.81,4.61-41.73,6.86s-27.84,4.48-41.78,6.61l-20.91,3.18c-7,1-14,2.07-20.94,3l-.05-.31c6.89-1.48,13.81-2.87,20.71-4.31l20.74-4.16c13.82-2.76,27.68-5.38,41.52-8.08S194,184,207.91,181.46c6.94-1.22,13.88-2.49,20.84-3.6l10.43-1.71c3.47-.61,7-1.1,10.71-.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "166.745px 190.806px"
    },
    id: "elwjpit22688e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22,177.23c-2.77,2.68-6,4-9.35,5.2l-9.9,3.74c-6.58,2.52-13.22,4.89-19.84,7.3-13.27,4.75-26.6,9.37-39.91,14s-26.64,9.24-40,13.76l-20,6.77c-6.7,2.21-13.38,4.46-20.09,6.62l-.11-.29c6.54-2.66,13.1-5.23,19.65-7.84l19.7-7.7c13.14-5.12,26.33-10.1,39.49-15.16s26.35-10,39.57-14.93c6.62-2.41,13.23-4.87,19.9-7.16l10-3.51c3.32-1.2,6.67-2.29,10.52-2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "170.62px 205.301px"
    },
    id: "eltxw2sgddoar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32,177.18c-2.26,3.12-5.25,5-8.31,6.75l-9.09,5.39c-6,3.63-12.17,7.12-18.28,10.64-12.24,7-24.56,13.85-36.87,20.72s-24.63,13.73-37,20.5l-18.56,10.14c-6.21,3.34-12.4,6.72-18.63,10l-.16-.27c6-3.76,12-7.43,18-11.14l18.06-11c12.05-7.33,24.18-14.52,36.26-21.79s24.2-14.47,36.38-21.57c6.1-3.53,12.18-7.09,18.35-10.51l9.21-5.18c3.06-1.77,6.17-3.42,10-3.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "176.87px 218.68px"
    },
    id: "ello7slhspqpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41,177.11c-1.68,3.47-4.3,5.83-7,8.1l-8,6.89c-5.33,4.62-10.76,9.12-16.16,13.65-10.84,9-21.78,17.9-32.71,26.8s-21.87,17.8-32.88,26.62l-16.51,13.21c-5.54,4.36-11,8.77-16.62,13.1l-.2-.24c5.23-4.74,10.52-9.4,15.78-14.09l15.88-14c10.6-9.31,21.29-18.5,31.92-27.76S205.22,211,216,201.86c5.4-4.53,10.77-9.1,16.25-13.54l8.18-6.7c2.7-2.26,5.47-4.44,9.18-5.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "185.37px 230.8px"
    },
    id: "elxwmzsipzhoj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49,177c-1.06,3.71-3.23,6.49-5.49,9.19l-6.7,8.18c-4.44,5.48-9,10.85-13.54,16.25-9.11,10.75-18.35,21.41-27.56,32.08s-18.45,21.32-27.76,31.91l-14,15.89c-4.7,5.25-9.36,10.55-14.09,15.78l-.24-.2c4.33-5.57,8.73-11.08,13.1-16.62L167.45,273c8.82-11,17.75-21.91,26.61-32.87s17.8-21.87,26.81-32.72c4.53-5.4,9-10.83,13.65-16.15l6.89-8c2.27-2.7,4.63-5.32,8.1-7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "195.8px 241.27px"
    },
    id: "el1htajcarx6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56,176.94c-.4,3.84-2.06,6.95-3.82,10l-5.18,9.22c-3.42,6.17-7,12.25-10.51,18.35-7.11,12.18-14.35,24.27-21.57,36.38S195,275.1,187.69,287.14l-11,18.07c-3.72,6-7.39,12-11.14,18l-.27-.16c3.3-6.23,6.68-12.42,10-18.64l10.15-18.55c6.77-12.37,13.67-24.67,20.5-37s13.73-24.63,20.72-36.88c3.52-6.1,7-12.23,10.63-18.27l5.4-9.1c1.76-3,3.63-6,6.75-8.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "207.92px 249.76px"
    },
    id: "el8uytspig1t5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.61,176.84c.27,3.85-.82,7.2-2,10.51l-3.5,10c-2.29,6.67-4.75,13.27-7.16,19.9C233,230.45,228,243.62,223,256.8s-10,26.35-15.16,39.48L200.13,316c-2.61,6.55-5.18,13.11-7.84,19.65l-.3-.11c2.17-6.72,4.42-13.4,6.63-20.09l6.77-20c4.52-13.36,9.18-26.67,13.76-40s9.24-26.64,14-39.91c2.41-6.62,4.78-13.26,7.3-19.84l3.73-9.9c1.21-3.31,2.53-6.58,5.21-9.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "221.321px 256.05px"
    },
    id: "el6qtmyn2wwvl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.64,176.73c.93,3.74.44,7.24-.17,10.71l-1.72,10.43c-1.1,7-2.37,13.9-3.59,20.84-2.52,13.87-5.19,27.71-7.83,41.56S232,288,229.25,301.79l-4.16,20.74c-1.44,6.9-2.83,13.82-4.31,20.71l-.31-.05c1-7,2-14,3-20.94l3.19-20.91c2.13-13.94,4.41-27.85,6.61-41.78s4.48-27.84,6.86-41.73c1.22-7,2.4-13.89,3.74-20.82l2-10.39c.61-3.47,1.34-6.92,3.5-10.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "235.814px 259.875px"
    },
    id: "elbtfkd8c1m4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.65,176.62c1.57,3.52,1.69,7,1.69,10.57l.12,10.57c.12,7.05.08,14.1.08,21.15-.07,14.1-.29,28.19-.49,42.29s-.43,28.2-.75,42.29l-.5,21.15c-.21,7.05-.38,14.1-.64,21.14h-.32c-.26-7-.43-14.09-.64-21.14l-.5-21.15c-.32-14.09-.49-28.19-.75-42.29s-.42-28.19-.49-42.29c0-7,0-14.1.08-21.15l.12-10.57c0-3.52.12-7.05,1.69-10.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "250.003px 261.2px"
    },
    id: "elwvjjku6ye2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.64,176.51c2.16,3.19,2.89,6.64,3.5,10.11l2,10.39c1.34,6.93,2.52,13.87,3.74,20.82,2.38,13.89,4.61,27.81,6.86,41.73s4.48,27.84,6.61,41.78l3.19,20.91c1,7,2.06,13.95,3,20.94l-.31.05c-1.48-6.89-2.87-13.81-4.31-20.71l-4.16-20.74c-2.76-13.83-5.38-27.68-8.08-41.52s-5.31-27.69-7.83-41.56c-1.22-6.94-2.49-13.88-3.59-20.84l-1.72-10.43c-.61-3.47-1.1-7-.17-10.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "264.196px 259.875px"
    },
    id: "elwcf4xruw1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.61,176.4c2.68,2.77,4,6,5.21,9.35l3.73,9.9c2.52,6.58,4.89,13.22,7.3,19.84,4.76,13.27,9.37,26.59,14,39.91s9.24,26.64,13.76,40l6.77,20c2.21,6.69,4.46,13.37,6.63,20.09l-.3.11c-2.66-6.54-5.23-13.1-7.84-19.65l-7.7-19.71C287.05,283.15,282.07,270,277,256.8s-10-26.35-14.93-39.57c-2.41-6.63-4.87-13.23-7.16-19.9l-3.5-10c-1.21-3.31-2.3-6.66-2-10.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "278.685px 256px"
    },
    id: "el2deto8co9ug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56,176.3c3.12,2.26,5,5.25,6.75,8.3l5.4,9.1c3.63,6,7.11,12.17,10.63,18.27,7,12.25,13.85,24.57,20.72,36.88s13.73,24.63,20.5,37l10.15,18.55c3.33,6.22,6.71,12.41,10,18.64l-.27.16c-3.75-6-7.42-12-11.14-18l-11-18.07c-7.32-12-14.52-24.17-21.79-36.25s-14.46-24.2-21.57-36.38c-3.53-6.1-7.09-12.18-10.51-18.35l-5.18-9.22c-1.76-3.05-3.42-6.16-3.82-10Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "292.07px 249.75px"
    },
    id: "elywh9udoefe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49,176.2c3.47,1.69,5.83,4.31,8.1,7l6.89,8c4.62,5.32,9.12,10.75,13.65,16.15,9,10.85,17.9,21.79,26.81,32.72S323.73,262,332.55,273l13.21,16.52c4.37,5.54,8.77,11.05,13.1,16.62l-.24.2c-4.73-5.23-9.39-10.53-14.09-15.78l-14-15.89c-9.31-10.59-18.5-21.28-27.76-31.91s-18.45-21.33-27.56-32.08c-4.53-5.4-9.1-10.77-13.54-16.25l-6.7-8.18c-2.26-2.7-4.43-5.48-5.49-9.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "304.17px 241.27px"
    },
    id: "elu37z0u7b4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41,176.12c3.72,1.06,6.49,3.24,9.19,5.5l8.18,6.7c5.48,4.44,10.85,9,16.25,13.54,10.75,9.11,21.41,18.34,32.08,27.56s21.32,18.45,31.92,27.76l15.88,14c5.26,4.69,10.55,9.35,15.78,14.09l-.2.24c-5.57-4.33-11.08-8.74-16.62-13.1l-16.51-13.21c-11-8.82-21.92-17.75-32.88-26.62s-21.87-17.79-32.71-26.8c-5.4-4.53-10.83-9-16.16-13.65l-8-6.89c-2.7-2.27-5.32-4.63-7-8.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "314.65px 230.815px"
    },
    id: "eljv8ttia29uo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32,176.06c3.84.4,6.95,2.05,10,3.82l9.21,5.18c6.17,3.42,12.25,7,18.35,10.51,12.18,7.1,24.28,14.34,36.38,21.57s24.21,14.46,36.26,21.79l18.06,11c6,3.71,12,7.38,18,11.14l-.16.27c-6.23-3.3-12.42-6.68-18.63-10l-18.56-10.14c-12.37-6.77-24.67-13.67-37-20.5S297.6,207,285.36,200c-6.11-3.52-12.24-7-18.28-10.64L258,183.93c-3.06-1.76-6.05-3.63-8.31-6.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "323.135px 218.7px"
    },
    id: "el7pgauhooiqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22,176c3.85-.27,7.2.82,10.52,2l10,3.51c6.67,2.29,13.28,4.75,19.9,7.16,13.22,4.88,26.39,9.91,39.57,14.93s26.35,10,39.49,15.16l19.7,7.7c6.55,2.61,13.11,5.18,19.65,7.84l-.11.29c-6.71-2.16-13.39-4.41-20.09-6.62l-20-6.77c-13.36-4.52-26.66-9.18-40-13.76s-26.64-9.25-39.91-14c-6.62-2.41-13.26-4.78-19.84-7.3l-9.9-3.74c-3.31-1.2-6.58-2.52-9.35-5.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.45px 205.274px"
    },
    id: "eliaxd0lyoocj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,176c3.75-.93,7.24-.44,10.71.17l10.43,1.71c7,1.11,13.9,2.38,20.84,3.6,13.87,2.52,27.72,5.18,41.56,7.83s27.69,5.32,41.52,8.08l20.74,4.16c6.9,1.44,13.82,2.83,20.71,4.31l-.05.31c-7-1-14-2-20.94-3l-20.91-3.18c-13.94-2.13-27.85-4.41-41.78-6.61s-27.84-4.48-41.73-6.86c-6.94-1.22-13.89-2.4-20.81-3.74l-10.39-2c-3.48-.61-6.92-1.35-10.12-3.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "333.255px 190.826px"
    },
    id: "el7yev61a9j2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,176c3.52-1.57,7.05-1.69,10.57-1.69l10.58-.13c7-.12,14.09-.07,21.14-.07,14.1.07,28.2.29,42.29.49s28.2.43,42.29.75l21.15.49c7.05.22,14.1.39,21.15.65v.31c-7.05.27-14.1.44-21.15.65l-21.15.5c-14.09.32-28.19.49-42.29.74s-28.19.43-42.29.5c-7.05,0-14.1,0-21.14-.08L260.57,179c-3.52,0-7-.12-10.57-1.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "334.585px 176.645px"
    },
    id: "elmbk3t8vhe9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89,176c3.2-2.16,6.64-2.89,10.12-3.5l10.39-2c6.92-1.34,13.87-2.52,20.81-3.75,13.89-2.37,27.81-4.61,41.73-6.85s27.84-4.48,41.78-6.61l20.91-3.19c7-1,13.95-2.07,20.94-3l.05.31c-6.89,1.48-13.81,2.87-20.71,4.31l-20.74,4.16c-13.83,2.76-27.68,5.38-41.52,8.07s-27.69,5.32-41.56,7.83c-6.94,1.23-13.88,2.5-20.84,3.6l-10.43,1.72c-3.47.61-7,1.1-10.71.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "333.255px 162.443px"
    },
    id: "ele3kc2nqplt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.78,176c2.77-2.68,6-4,9.35-5.21l9.9-3.73c6.58-2.52,13.22-4.89,19.84-7.3,13.27-4.76,26.6-9.37,39.91-14s26.64-9.25,40-13.77l20-6.76c6.7-2.21,13.38-4.46,20.09-6.63l.11.3c-6.54,2.65-13.1,5.22-19.65,7.84l-19.7,7.69c-13.14,5.13-26.33,10.11-39.49,15.17s-26.35,10-39.57,14.93c-6.62,2.41-13.23,4.86-19.9,7.16l-10,3.5c-3.32,1.21-6.67,2.3-10.52,2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.38px 147.92px"
    },
    id: "eli5ef6vkrg2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68,176.06c2.26-3.12,5.25-5,8.31-6.76l9.09-5.39c6-3.63,12.17-7.11,18.28-10.64,12.24-7,24.56-13.84,36.87-20.71s24.63-13.73,37-20.5l18.56-10.15c6.21-3.33,12.4-6.71,18.63-10l.16.27c-6,3.75-12,7.42-18,11.14l-18.06,11c-12,7.32-24.18,14.52-36.26,21.79s-24.2,14.46-36.38,21.57c-6.1,3.52-12.18,7.09-18.35,10.51l-9.21,5.18c-3.06,1.76-6.17,3.42-10,3.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "323.13px 134.55px"
    },
    id: "el2mezszb139d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.58,176.12c1.69-3.47,4.31-5.83,7-8.09l8-6.89c5.33-4.62,10.76-9.12,16.16-13.65,10.84-9,21.78-17.9,32.71-26.81s21.87-17.79,32.88-26.61l16.51-13.21c5.54-4.37,11.05-8.77,16.62-13.1l.2.24c-5.23,4.73-10.52,9.39-15.78,14.09L348,96.06c-10.6,9.31-21.29,18.5-31.92,27.76S294.78,142.26,284,151.38c-5.4,4.53-10.77,9.1-16.25,13.53l-8.18,6.7c-2.7,2.27-5.47,4.44-9.19,5.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "314.62px 122.435px"
    },
    id: "el63y0fza7ln7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51,176.2c1.06-3.71,3.23-6.49,5.49-9.19l6.7-8.17c4.44-5.48,9-10.85,13.54-16.25,9.11-10.75,18.34-21.41,27.56-32.08s18.45-21.33,27.76-31.92l14-15.88c4.7-5.26,9.36-10.55,14.09-15.78l.24.2c-4.33,5.57-8.73,11.08-13.1,16.62L332.55,80.26c-8.82,11-17.75,21.92-26.61,32.88s-17.8,21.87-26.81,32.71c-4.53,5.4-9,10.83-13.65,16.15l-6.89,8c-2.27,2.7-4.63,5.32-8.1,7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "304.2px 111.965px"
    },
    id: "elbq07c9tnpkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.44,176.3c.4-3.84,2.06-7,3.82-10l5.18-9.22c3.42-6.16,7-12.24,10.51-18.35,7.11-12.17,14.35-24.27,21.57-36.38S305,78.14,312.31,66.09l11-18.06c3.72-6,7.39-12,11.14-18l.27.15c-3.3,6.24-6.68,12.43-10,18.64L314.56,67.39c-6.77,12.37-13.67,24.66-20.5,37S280.33,129,273.34,141.26c-3.52,6.11-7,12.23-10.63,18.28l-5.4,9.09c-1.76,3.05-3.63,6-6.75,8.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "292.08px 103.485px"
    },
    id: "elqwi6g3bf8oj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.39,176.4c-.27-3.85.82-7.21,2-10.52l3.5-10c2.29-6.66,4.75-13.27,7.16-19.89C267,122.79,272,109.61,277,96.44s10-26.35,15.16-39.49l7.7-19.7c2.61-6.55,5.18-13.12,7.84-19.65l.3.11c-2.17,6.71-4.42,13.39-6.63,20.09l-6.77,20c-4.52,13.36-9.18,26.66-13.76,40s-9.24,26.63-14,39.91c-2.41,6.62-4.78,13.26-7.3,19.84l-3.73,9.89c-1.21,3.32-2.53,6.58-5.21,9.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "278.674px 97.2px"
    },
    id: "elwjaxqiyvxb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,176.51c-.93-3.75-.44-7.24.17-10.71l1.72-10.43c1.1-7,2.37-13.9,3.59-20.84,2.52-13.87,5.19-27.72,7.83-41.56s5.32-27.7,8.08-41.52l4.16-20.74c1.44-6.91,2.83-13.82,4.31-20.71l.31.05c-1,7-2,14-3,20.94L273.31,51.9c-2.13,13.94-4.41,27.85-6.61,41.78s-4.48,27.84-6.86,41.73c-1.22,6.94-2.4,13.89-3.74,20.81l-2,10.39c-.61,3.47-1.34,6.92-3.5,10.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "264.186px 93.365px"
    },
    id: "el1xank45plf2",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-8",
    className: "animable",
    style: {
      transformOrigin: "354.372px 222.254px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8",
    className: "animable",
    style: {
      transformOrigin: "354.372px 222.254px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-8",
    className: "animable",
    style: {
      transformOrigin: "359.844px 284.97px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351,342.9c.2,2.57.53,4.88-.47,7.71-1.43,4.06-4.46,5.92-6.24,7.52a30.39,30.39,0,0,0-5.18,6.28c-1.27,2-1.79,4.41-5.41,6.76-1.87,1.21-9.17,2.16-12.81-.15-2.1-1.34-3.06-1.83-2.92-5.49s15.32-4.13,15.32-4.13Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "334.587px 357.666px"
    },
    id: "elea2rjwb5kqv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.4,354.61c-.94.36-1.18,2.16-1.33,5.75-.11,2.71-1.25,6.68,2.49,8.39,3,1.38,8.65,3,13.95-1.31,3.16-2.58,4.27-6,7.89-9.9,3.15-3.38,6.43-4.52,7.83-11.27.9-4.34.19-6.14-2.73-7.39-4-1.71-10.33,3.89-13.48,4.77C331.31,344.41,320.35,354.25,319.4,354.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "334.208px 354.394px"
    },
    id: "elx232hf4gkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,343.65c.17,0,.35-.12.53-.19a10.36,10.36,0,0,1,8.7,5.71c.54,1.18-1.11,2.1-2.09,1.18-2.25-4.46-6.86-5.45-8.7-5.67A4.63,4.63,0,0,1,334,343.65Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "337.888px 347.092px"
    },
    id: "elf2s26bj57tg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.42,345.69a10.26,10.26,0,0,1,8.08,5.66c.54,1.18-1.11,2.1-2.09,1.18a10.61,10.61,0,0,0-7.25-5.41C330.59,346.61,331,346.12,331.42,345.69Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "334.883px 349.297px"
    },
    id: "elclw48j615d8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.38,351.27s-.31-8-11.18-9.16l-.62.35a9.36,9.36,0,0,1,5.34-4.12c3.62-1,6.47,0,8.37,2.4S350.26,349.7,348.38,351.27Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "343.826px 344.613px"
    },
    id: "elia7sve6apq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.86,380.77a8.27,8.27,0,0,1,.11,4.37c-.42.88-3,3.77-8.39,4.83s-12.7,0-15.86-.2-13.1,1-16.26,1.45c-5,.67-8.78-.41-10.63-2.21a3.32,3.32,0,0,1-.75-2.62,13.23,13.23,0,0,1,.53-3.53Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "378.129px 386.095px"
    },
    id: "elgw7xdp4lxsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.17,378.9a20.61,20.61,0,0,0-.46,6.45c.64,1.57,2.39,2.43,3.81,2.88,3.73,1.19,6.58,1,10.72.21a76,76,0,0,1,12.59-.77c3.26.22,7.74.84,11,.54a26,26,0,0,0,8.1-1.65c2.17-.93,4.39-2.12,4.93-4.36.64-4.71-1.34-6.8-3.58-8.11s-5.41-1.21-8.8-1.44c-3.08-.21-5.31-.21-8.05-.42a38.65,38.65,0,0,1-7-1c-2.06-.65-4.18-3.27-5.05-3.37,0,0-13.68-.1-15,0-1.5.13-2.88,2.18-2.89,7.64C353.48,376.05,353.25,378.49,353.17,378.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "378.308px 378.447px"
    },
    id: "elrrsho87ptva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.58,387.59c.43-3.4,1-10.76-5.26-15l-.79,0a15.44,15.44,0,0,1,8.64,0c5,1.33,7.23,5.37,6,9.64C404.15,382.18,403,386.33,395.58,387.59Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "397.016px 379.782px"
    },
    id: "eluph7zmk9rwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.33,371.5c2,1.79,2.72,5.87,2.72,5.87.27,1.53,3,1.75,2.77.28a16.06,16.06,0,0,0-2.39-5.68A4.78,4.78,0,0,0,377.33,371.5Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "380.082px 375.031px"
    },
    id: "elst1y99bj8lr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,372.2a9.85,9.85,0,0,1,2.84,5.56c.28,1.46,2.59,1.44,2.42,0,0,0-.26-3.61-2.42-5.3A3.06,3.06,0,0,0,383,372.2Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "385.634px 375.407px"
    },
    id: "ell0yzl883rk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.19,292.77c0-15.22.92-20.88.92-20.88s-1.33-24.45-.8-45.82c.8-31.84-.6-34.47,6.9-47.55,8.35,6.93,38.9,9.45,57.45,5.11.53,35.8.27,88.55-.44,98s-1.46,16.49-2.23,38.81c-.56,16.16-.39,51-.39,51-7.16,9.81-23.45,4-23.45,4s-5.09-58.8-4.64-69.69c.54-13.3,1.09-21,1.09-21s-2-27.72-2.91-34.65c0,0-1.11,10.67-1.82,20.11s-1.05,13.49-2,31c-1,17.95-3.22,53.31-3.22,53.31-6.81,6.82-21.78,3.13-21.78,3.13S315.19,303.55,315.19,292.77Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "347.563px 277.834px"
    },
    id: "el9y6y0720h1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfyidwle3abk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.19,292.77c0-15.22.92-20.88.92-20.88s-1.33-24.45-.8-45.82c.8-31.84-.6-34.47,6.9-47.55,8.35,6.93,38.9,9.45,57.45,5.11.53,35.8.27,88.55-.44,98s-1.46,16.49-2.23,38.81c-.56,16.16-.39,51-.39,51-7.16,9.81-23.45,4-23.45,4s-5.09-58.8-4.64-69.69c.54-13.3,1.09-21,1.09-21s-2-27.72-2.91-34.65c0,0-1.11,10.67-1.82,20.11s-1.05,13.49-2,31c-1,17.95-3.22,53.31-3.22,53.31-6.81,6.82-21.78,3.13-21.78,3.13S315.19,303.55,315.19,292.77Z",
    style: {
      opacity: 0.1,
      transformOrigin: "347.563px 277.834px"
    },
    className: "animable",
    id: "elnw7ubkbx5wg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3zxnttcbwii"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.69,250.1l-3.64-29a33.67,33.67,0,0,1-19.59-7.22s2.64,7.35,15.46,11.32l5.16,24.95.86,19.09Z",
    style: {
      opacity: 0.18,
      transformOrigin: "335.075px 241.56px"
    },
    className: "animable",
    id: "el73jwdcfcy47"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-8",
    className: "animable",
    style: {
      transformOrigin: "353.335px 130.217px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "354.14 104.94 354.14 122.42 334.15 121.35 334.73 100.79 354.14 104.94",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "344.145px 111.605px"
    },
    id: "el38oq25g76mr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.2,109.83c-6.11-.69-16.35,2.5-20.06,12.28-1.17,3.08-2.61,10.73-1.5,19.24s2.19,14.26,4.59,27.09c1.46,7.83,3.57,10.93,9.74,9A79.28,79.28,0,0,0,334.15,171Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "319.196px 143.869px"
    },
    id: "el1bdyvbqddrk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.67,120.69c2.07-4.92,8.93-11.81,17.59-10.84,2.37.27,5.2.67,5.2.67.77,3.16,11.42,5.21,19.68,3.26,3.78.8,11.68,2.17,13.75,2.86,5.94,2,8.82,7.93,10.07,29.45.79,13.68,3.22,31.48,3.23,43.49,0,2.09.3,12.9.3,12.9-10.45,5.51-31.32,5.33-42.81,4.29-10-.9-18.26-3.59-22.64-8s-1.82-12-1.2-22.83c.46-8,.46-12.28-2.2-24.67C308.94,134.12,309.25,126.47,311.67,120.69Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "345.672px 158.552px"
    },
    id: "eli3zoyi1gjqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.8,116.32c9.54,2.49,13.35,5.47,16.73,14.33,2.61,6.83,14.25,27.65,17.84,40.43,1.07,3.82,2.4,10.31-2,13.56-4.64,3.41-18.16,3.61-18.16,3.61-.11-4.79-.41-9.5-.82-14.16l-15-25.85A32.12,32.12,0,0,1,361,129.71C361.36,125,362.71,119.19,366.8,116.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "381.677px 152.285px"
    },
    id: "ello7g9kpk9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliu96y6iw6l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.37,174.09c.14,1.62.25,3.24.36,4.87a10.87,10.87,0,0,0,7.69,1.78C384.84,180,381.27,176.22,380.37,174.09Z",
    style: {
      opacity: 0.15,
      transformOrigin: "384.395px 177.471px"
    },
    className: "animable",
    id: "el0u7phl6x82sn"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367,81.3s4.55,6.91,4,7.59-3.86,1.29-3.86,1.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "369.023px 85.74px"
    },
    id: "ela811mk8bow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.34,62.2c9.21,1.94,12.89,4.64,13.46,20.37.55,15.3-1.37,20.34-3.38,22.4-1.36,1.39-8.89,1.64-12.69.6-4.76-1.32-15.51-5.13-20.54-12.82-5.93-9-7.48-21.3-1.14-26.33C339,59.34,350.6,61.41,354.34,62.2Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "346.93px 83.7544px"
    },
    id: "elgshmqtxamd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,105c-1.11,1.14-6.38,1.51-10.33,1l.05-2.28A22.4,22.4,0,0,0,364.42,105Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "359.255px 104.972px"
    },
    id: "elzadzbeitub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.57,59.07a4.63,4.63,0,0,0-1.78-.06,17.64,17.64,0,0,1-5.16.3c.78-.82,2.32-2.51,2.42-4a1.75,1.75,0,0,0-.75-1.76,2.1,2.1,0,0,0-1.55.11,38.84,38.84,0,0,1-3.85,1c-7.88,1.77-15.34-3-23.31-1.13-5.34,1.22-10,3.89-10.9,9.83-4.48,3.4-8.47,11.65-2.68,24.54,2.74,6.09,7.45,11.19,12.62,16.64a22.87,22.87,0,0,0,12.3.46c5.81-5.77,5-14.06,5-14.06s-3.22,3.48-7-1.66c-2.32-3.13-1.6-10.7,4.19-10.07a6.3,6.3,0,0,1,3.93,2.2A17.16,17.16,0,0,1,355,84.72a1.29,1.29,0,0,0,2.34,0,3.54,3.54,0,0,0,.43-2,14.31,14.31,0,0,0-1.57-6.37,7,7,0,0,0,4-2.89,5.87,5.87,0,0,0,.94-3.48A10.82,10.82,0,0,0,369,68.11a7.81,7.81,0,0,0,2.6-5.8A3.22,3.22,0,0,0,369.57,59.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "345.367px 79.3581px"
    },
    id: "elx139lwo1vn",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-8",
    className: "animable",
    style: {
      transformOrigin: "436.779px 246.087px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-8",
    className: "animable",
    style: {
      transformOrigin: "436.779px 246.087px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Arm--inject-8",
    d: "M410.36,133c-11.18,2.26-12.85,11.29-15.31,27.23s-3.1,21.63-2.79,28.11,3,25.21,2.39,32.23a51.79,51.79,0,0,0,2.92,23.08c2.29,3.74,7.44,8.29,11.95,8.28,1.75-.08,2.41-1.67,1.72-3.17-.78-1.1-4.65-21.95-.22-16.36a7,7,0,0,0,3.41,3.46c1.3.54,2.7-.42,1.75-1.67-2.47-3.88-2.18-8.59-3.42-12.83-1.6-5.48-4.45-5-4.52-10.06-.27-7.13.68-18,.41-25.14C411.84,170.37,418.94,144.18,410.36,133Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "404.34px 192.465px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-8",
    className: "animable",
    style: {
      transformOrigin: "439.166px 273.978px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.25,391.68c-1.09-5.31-.72-13.5-.63-18.29s5.2-70.94,5.57-77.91c.82-15.6-.41-21-1.69-41.3-2.73-43.23-8.93-62.33-8.93-62.33l-43-3.89c-3.95,13.58-11.64,15-12.8,33.65-.26,4.23,1.76,12.67,1.71,19.24l29.41,21.94,7.34,42.93a58.14,58.14,0,0,0-1.05,16.52c.29,4.14,1.25,15.92,2.08,22,2.37,17.27,6.05,30.88,6,32.47-.18,4.73-2.46,6-2.46,7.85a6.72,6.72,0,0,0,.79,3.29c.23.39.55.71.79,1.08a6.64,6.64,0,0,0,1.14,1.17,20.21,20.21,0,0,1,2.48,2.75c1.4,1.95,2.31-.83,3.12,1.43.51,1.45,1,2.9,1.55,4.35a38.31,38.31,0,0,0,1.52,4c3.16,6.6,12.05.73,14.59-.66C467.08,401.36,465.33,397,464.25,391.68Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "437.263px 296.832px"
    },
    id: "elw8g38zq7ens",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.65,412.1s-1.41,2.23-8.34-1.08-8.75-6.94-8.75-6.94,2.51-14.1,6.72-10.32S464.65,412.1,464.65,412.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "456.105px 402.975px"
    },
    id: "elpa3qo6iv9yr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elomcl74aoehg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.65,412.1s-1.41,2.23-8.34-1.08-8.75-6.94-8.75-6.94,2.51-14.1,6.72-10.32S464.65,412.1,464.65,412.1Z",
    style: {
      opacity: 0.2,
      transformOrigin: "456.105px 402.975px"
    },
    className: "animable",
    id: "ela3q25inx66o"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M447.15,381.23c1.48-.69,5.25,1.08,7.41,3.14a17.59,17.59,0,0,1,5.44,8.74c1.42,4.42,3.47,7,5.79,8.49,1.31.82,2.5.47,4-.17a6.26,6.26,0,0,1-1.33-.8c1.49-.11,3.51-.61,4.79-.77,4.85-.61,8,1.63,8.12,4.26,0,2.07-8.45,9-14.37,8.94-4.9,0-6.61.72-9-6.58s-3.2-11.38-5.59-6.61-3.8,15.69-3.8,15.69a3.65,3.65,0,0,1-4-.19s.1-7-.31-11.43-2.51-6.41-2-11.7S445.69,381.88,447.15,381.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "461.795px 398.572px"
    },
    id: "ely251gxiz8xg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ells01jwqzuem"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.15,381.23c1.48-.69,5.25,1.08,7.41,3.14a17.59,17.59,0,0,1,5.44,8.74c1.42,4.42,3.47,7,5.79,8.49,1.31.82,2.5.47,4-.17a6.26,6.26,0,0,1-1.33-.8c1.49-.11,3.51-.61,4.79-.77,4.85-.61,8,1.63,8.12,4.26,0,2.07-8.45,9-14.37,8.94-4.9,0-6.61.72-9-6.58s-3.2-11.38-5.59-6.61-3.8,15.69-3.8,15.69a3.65,3.65,0,0,1-4-.19s.1-7-.31-11.43-2.51-6.41-2-11.7S445.69,381.88,447.15,381.23Z",
    style: {
      opacity: 0.1,
      transformOrigin: "461.795px 398.572px"
    },
    className: "animable",
    id: "elisxnnfld64"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431,285.78c-.81,6.93-2.2,17.43-4,30C425.52,326.28,419.5,358,419.5,358c-.58,4.35-1.28,12.93-.53,18.29s2.21,9.84,6.85,10.74c-2.62,1.23-11.88,6.52-14.61-.27a38.46,38.46,0,0,1-1.26-4.12c-.43-1.48-.85-2.95-1.27-4.43-.66-2.31-1.61,1.21-2.88-.82a20.15,20.15,0,0,0-2.3-2.91,7.26,7.26,0,0,1-1.06-1.23c-.22-.4-.52-.73-.72-1.14a6.58,6.58,0,0,1-.58-3.33c.12-1.87,2.47-3,2.95-7.67a50.67,50.67,0,0,0-.15-6.12s-1.08-15.44-2.35-32.81c-.44-6.08-.62-15.94-.18-20.06a97,97,0,0,1,2.77-14.4l.29-46.9,29.41,21.94Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "417.498px 315.487px"
    },
    id: "elohy84lke95l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.08,396.72s-1.55,2.14-8.26-1.6-8.29-7.48-8.29-7.48,3.4-13.92,7.36-9.88S418.08,396.72,418.08,396.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.805px 387.177px"
    },
    id: "elj4p51ck5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwt3rez6eoa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.08,396.72s-1.55,2.14-8.26-1.6-8.29-7.48-8.29-7.48,3.4-13.92,7.36-9.88S418.08,396.72,418.08,396.72Z",
    style: {
      opacity: 0.2,
      transformOrigin: "409.805px 387.177px"
    },
    className: "animable",
    id: "elqd6qcj8arqo"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.71,365.62c1.52-.6,5.17,1.41,7.2,3.6,2.68,2.87,3.31,4.61,4.37,8.83a13.4,13.4,0,0,0,5.6,8.27c1.26.9,2.47.62,4,.08a6.47,6.47,0,0,1-1.27-.87c1.49,0,3.53-.39,4.83-.47,4.87-.3,7.92,2.13,7.83,4.76-.13,2.07-9,8.42-14.9,8-4.9-.34-6.65.3-8.55-7.13s-2.48-11.56-5.16-6.95-4.79,15.42-4.79,15.42a3.67,3.67,0,0,1-4-.45s.54-7,.42-11.43-2-5.75-1.07-11S401.21,366.17,402.71,365.62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "416.117px 382.534px"
    },
    id: "elob0u08uu5bb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7lwaniw0h0h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.71,365.62c1.52-.6,5.17,1.41,7.2,3.6,2.68,2.87,3.31,4.61,4.37,8.83a13.4,13.4,0,0,0,5.6,8.27c1.26.9,2.47.62,4,.08a6.47,6.47,0,0,1-1.27-.87c1.49,0,3.53-.39,4.83-.47,4.87-.3,7.92,2.13,7.83,4.76-.13,2.07-9,8.42-14.9,8-4.9-.34-6.65.3-8.55-7.13s-2.48-11.56-5.16-6.95-4.79,15.42-4.79,15.42a3.67,3.67,0,0,1-4-.45s.54-7,.42-11.43-2-5.75-1.07-11S401.21,366.17,402.71,365.62Z",
    style: {
      opacity: 0.1,
      transformOrigin: "416.117px 382.534px"
    },
    className: "animable",
    id: "eleuqtiq8f905"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M468.54,236.83c-2.86-24.31-5.28-32.53-7.39-46,0,0,.55-10.08,1-14.65,5.5-5.41,6.65-12.82,3.57-20.09-3.9-9.2-7.05-16.17-13-17.88A101.91,101.91,0,0,0,441,135.6s-10.21,1.52-16.13.78c-9.21-1.15-8.55-3.51-8.49-4.49,0,0-2,.33-5.2.9-2,.36-6.52,2.17-8.23,10.48-3.7,18,7.77,36.43,8.32,47-4.1,10.77-7.42,15.39-9.05,25-1.46,8.6.29,21.27-.38,29.12s-3,37.54-3,37.54,7,6.43,27.77,9.49,30.5,1.27,30.5,1.27l2-27.45,3.45,26.93s6.74-1.14,10-3.94C472.63,288.18,470.5,253.44,468.54,236.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "435.701px 212.55px"
    },
    id: "el3gm51zhcdqm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-8",
    className: "animable",
    style: {
      transformOrigin: "434.809px 136.039px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.07,92c1.43-1.93,1.23-4.81.2-7s-3-4.4-8.56-6.78c-6.56-2.83-24.49-4.71-31.36,7.29-1,1.79,17.71,33.51,17.34,40.25,4.11-5,17.61-22.46,17.61-22.46,3.37-1.73,5.39-3.13,5.89-6.46A8.19,8.19,0,0,0,451.07,92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.764px 100.934px"
    },
    id: "elevvsrs03e9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.1,101.31s5.24,7.33,4.76,8a24,24,0,0,1-3.31,2.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "451.496px 106.58px"
    },
    id: "elx8u2dch92wj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.28,87.74c3.25,1.27,7.35,3.41,7.62,10.33.07,1.83-.85,4.36,0,6.72,3.48,10.09.83,18.9-1,20.93-1.27,1.37-8.29,2.44-12.07,1.68-4.73-1-15.13-4.8-20.45-11.71-6.26-8.13-8.39-19.5-2.43-24.55C422.28,84,438.8,86.39,442.28,87.74Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "431.013px 106.949px"
    },
    id: "elwh3osd3ohy9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.32,128.83h0l.43-7.54,18.89,3.33-.42,4.22c-.23,2.38-.45,5.91,3.22,6.89a77.82,77.82,0,0,1,10.79,3.08s-15.93,3.55-26.22,1.85-12.08-8.32-12.08-8.32C417.63,131.84,419.18,131.22,419.32,128.83Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "433.08px 131.205px"
    },
    id: "eln82c1bv05xe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.47,126c-1.58,1-5.16,2-10.13,1.62l.22-2.57a26.66,26.66,0,0,0,4.79,1.07A17.49,17.49,0,0,0,448.47,126Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "443.405px 126.376px"
    },
    id: "elhjc7w9otlja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,143.27c1.71-8.31,6.22-10.12,8.23-10.48,3.21-.57,5.2-.9,5.2-.9-.06,1-.72,3.34,8.49,4.49,5.92.74,16.13-.78,16.13-.78a101.91,101.91,0,0,1,11.63,2.6c6,1.71,9.12,8.68,13,17.88,3.08,7.27,1.93,14.68-3.57,20.09-.11,4.82,1.43,13.17-1,14.65-12.87,7.9-44.52,5.92-49.84-.59-2-2.27-1.21-6.67-2.54-10.77C405.44,169.2,400.35,156.13,403,143.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "434.809px 163.931px"
    },
    id: "el2duruqhzitb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcv49728y7lg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403,143.27c1.71-8.31,6.22-10.12,8.23-10.48,3.21-.57,5.2-.9,5.2-.9-.06,1-.72,3.34,8.49,4.49,5.92.74,16.13-.78,16.13-.78a101.91,101.91,0,0,1,11.63,2.6c6,1.71,9.12,8.68,13,17.88,3.08,7.27,1.93,14.68-3.57,20.09-.11,4.82,1.43,13.17-1,14.65-12.87,7.9-44.52,5.92-49.84-.59-2-2.27-1.21-6.67-2.54-10.77C405.44,169.2,400.35,156.13,403,143.27Z",
    style: {
      opacity: 0.1,
      transformOrigin: "434.809px 163.931px"
    },
    className: "animable",
    id: "ellh34wgdqms"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446.14,88.29a76.69,76.69,0,0,0-17.83-5.1c-5.32-.77-14.87,1.65-15.42,1.84-6,2.15-8.49,8-8.41,14.57v49.73c10.11,9.42,34.2,2.35,34.2,2.35v-36h0a9.37,9.37,0,0,1-1.52,1.19,2.49,2.49,0,0,1-1,.2,5.5,5.5,0,0,1-4.46-2.56c-2.47-3.57-1.88-9.32,1.86-10.11,3.26-.69,4.3,1.61,5.1,3.09.57,1,1,1.62,2.35,1.06,2.18-.91,2.91-2.83,3.2-5.13a6.1,6.1,0,0,0,0-1.21,8.33,8.33,0,0,0,4.23-1.62C449.1,95.59,448.7,91.58,446.14,88.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "426.6px 118.633px"
    },
    id: "eloerri5zdqfe",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-8",
    d: "M452.67,138.2c-8.31,5.43-1.32,36.62.17,51.94.59,6.05,1.67,7.44,4.25,17.33,1.75,6.7,3.94,12.06,4.66,21,.38,4.7-1.21,10.3-.43,15,.55,3.9-.07,7.85-.11,11.73-.34,3-.86,6.42.66,9.17a2.08,2.08,0,0,0,3.44.12c.77-.87.79-2.12,1.34-3.11a2.26,2.26,0,0,1,1.81-.86c1.74-.28,2.56-2,3.32-3.42a1.38,1.38,0,0,1,1.25-.8c3.33-1.15,4-5.93,4.53-9,2.47-10.76-.08-21.82-1.75-32.51-.63-4.64-2.18-13.64-3.53-24.78,0,0-2.07-26-2.93-33.05C467.86,144.77,465.13,141.53,452.67,138.2Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "463.63px 201.771px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-8",
    className: "animable",
    style: {
      transformOrigin: "150.128px 222.164px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-8",
    className: "animable",
    style: {
      transformOrigin: "150.128px 222.164px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-8",
    className: "animable",
    style: {
      transformOrigin: "186.677px 176.335px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.61,117.38c10.11,3.32,11.95,10.84,14.42,26.78s3.16,21.62,2.86,28.1-4.18,25.22-3.55,32.24a51.76,51.76,0,0,1-2.92,23.07c-2.29,3.74-7.44,8.3-11.95,8.29-1.75-.09-2.41-1.68-1.72-3.18.78-1.1,4.65-21.94.22-16.35a7,7,0,0,1-3.41,3.46c-1.3.53-2.7-.42-1.75-1.67,2.47-3.88,2.18-8.6,3.42-12.83,1.6-5.49,4.45-5,4.52-10.06.27-7.14.54-18.12.81-25.25C181.14,156,170,131.61,181.61,117.38Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "186.227px 176.62px"
    },
    id: "elmwbn03colx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.07,116.81c6.89,1.4,9.88,4,12.18,9.43s3.89,15.42,5,20.71,2.79,18.27,2.59,22.16-3,18.11-3.33,20.85a72.22,72.22,0,0,1-14.93-2.09l.2-18.36s-5.39-24.95-6.39-29.44S171.74,125.14,180.07,116.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "187.022px 153.385px"
    },
    id: "elx6fmx0sa7n",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-8",
    className: "animable",
    style: {
      transformOrigin: "145.479px 288.702px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.81,355.57c0,1.62.31,2.25-1.68,3.72s-6.31,2.14-9.59,1.25a8.83,8.83,0,0,1-5.3-3.19,43.62,43.62,0,0,1-3.08-4.65c-.57-.73-3.24-2.13-5.82-3.27s-7.9-3.61-9.77-8a10.44,10.44,0,0,1-.57-7.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.687px 347.41px"
    },
    id: "elp9omb19350a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.49,333.24c5.25,3.43,9.66,12,16.85,9.42.36,4.22,1.48,8.76.47,12.91-3.06,3.78-9.76,4.5-13.62,1.78-1.94-1.65-3-3.59-4.91-5.34a18.78,18.78,0,0,0-5.16-3.15,53.65,53.65,0,0,1-6.25-3.46C146.26,336.84,152,321.17,170.49,333.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "170.04px 343.913px"
    },
    id: "el1e3hw4ad2fr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbtyr0cw58d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.49,333.24c5.25,3.43,9.66,12,16.85,9.42.36,4.22,1.48,8.76.47,12.91-3.06,3.78-9.76,4.5-13.62,1.78-1.94-1.65-3-3.59-4.91-5.34a18.78,18.78,0,0,0-5.16-3.15,53.65,53.65,0,0,1-6.25-3.46C146.26,336.84,152,321.17,170.49,333.24Z",
    style: {
      opacity: 0.1,
      transformOrigin: "170.04px 343.913px"
    },
    className: "animable",
    id: "elqd26xdxhqc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152,380.13c0,1.76-.12,3.08-1.2,3.83s-9.12,2.07-11.26,2.31-2.46-1.15-4-.66-5,3.07-10.24,4.22-9.55,2.4-16.83,0-8-5.22-7.91-7.68S152,380.13,152,380.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "126.277px 385.65px"
    },
    id: "elwu2yh0h4lg9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92,363.69c1.18,5,2.42,12.6,1.06,16.44-1.47,1.45-6.39,2.31-10.68,2.89a33.09,33.09,0,0,0-11.36,3.53c-8.32,3.48-23,4.74-28.8-3.09-5.82-10.47,24.49-7.9,28.21-20C130.7,359.05,145.42,364.88,150.92,363.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "126.487px 375.53px"
    },
    id: "elxauvgugqbce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln8huusmoap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.92,363.69c1.18,5,2.42,12.6,1.06,16.44-1.47,1.45-6.39,2.31-10.68,2.89a33.09,33.09,0,0,0-11.36,3.53c-8.32,3.48-23,4.74-28.8-3.09-5.82-10.47,24.49-7.9,28.21-20C130.7,359.05,145.42,364.88,150.92,363.69Z",
    style: {
      opacity: 0.1,
      transformOrigin: "126.487px 375.53px"
    },
    className: "animable",
    id: "elczyp4vxdym"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.19,299.34c-4.06-43,.26-77.51-3.61-112.15,0,0-59.64-6.53-61.12,14s-1.74,78.28-1.27,87.33c.22,9.16,3.52,71.1,3.52,77.56,15,7.45,24.31,1.82,24.31,1.82-.09-8.33,6.43-45.55,2.89-65.87l2.4-39.62s10.3,66.9,12,83.57c4.43,6.57,17,5,19.11,1.07C188.46,347.05,191.61,312,190.19,299.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "157.267px 278.071px"
    },
    id: "el5jijx94c0gf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw0p0eigi0o8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.3,255.89c-.48-7.75-.94-15.1-1.44-19.6l.56-3.52c4.53-1.61,11.68-7.33,13.48-13.92-6.59,8.24-18,10.33-18,10.33l-2.66,33.23,4.5,29.75L159.9,261l3.34-20.86c.37,4.33.72,10,1.09,15.84.71,11.42,1.45,23.23,2.46,28.84,1.52,8.53,5.81,53,6.91,64.61.33.14.67.26,1,.37-1-10.81-5.41-56.47-7-65.15C166.75,279.06,166,267.28,165.3,255.89Zm-33.2,24.83c.3-23.52,1.09-65.22,3-80.38l-1-.12c-.66,5.25-1.18,13.68-1.6,23.43-4.57-5.61-3.9-16.13-3.44-22.81,0-.59.07-1.14.1-1.66l-1-.06c0,.51-.07,1.07-.1,1.65-.49,7.16-1.24,18.62,4.35,24.3-.75,18.21-1.14,40.63-1.33,55.63-.26,19.71,2.86,68.78,4.16,88.26.33.09.66.16,1,.24C135,349.94,131.85,300.5,132.1,280.72Z",
    style: {
      opacity: 0.1,
      transformOrigin: "152.813px 284.16px"
    },
    className: "animable",
    id: "el960dwz1fcm4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-8",
    className: "animable",
    style: {
      transformOrigin: "150.592px 151.193px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.47,81.68s-6.86,8.27-6.36,9,4.3,2.5,4.3,2.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "131.277px 87.43px"
    },
    id: "elrotivp3buw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,67.55c-3.63,1.24-5.41,4.74-5.76,10.74a27.77,27.77,0,0,1-1,7.35c-2.38,7.28-1.8,19.71.17,22,1.32,1.56,9.81,4.13,14,3.45,5.24-.84,16.85-4.59,23-12,7.24-8.66,10.1-21.07,3.77-26.89C165.55,64.09,144.19,66.22,140.31,67.55Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "154.99px 88.7352px"
    },
    id: "el0lc67us0uleb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,114.11l-.79-9.5-20.78,3.67.46,4.65c.25,2.61.49,6.5-3.54,7.57A93.47,93.47,0,0,0,132,124.15s20.21,3.4,31.53,1.53c2.89-.47,13.5-9.9,13.3-9.15C172.73,116,168.26,116.74,168.1,114.11Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "154.416px 115.426px"
    },
    id: "elwmu2bkx6tus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.07,108c1.69,1.2,6.65,3.32,12.76,3.32l-.3-3a30.51,30.51,0,0,1-7.34.66A15.67,15.67,0,0,1,134.07,108Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "140.45px 109.66px"
    },
    id: "elplxzpahadz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25,67.83a5.32,5.32,0,0,0-1,2.69,4.59,4.59,0,0,0,2.1,4.23,4,4,0,0,0,4.62-.4,5.09,5.09,0,0,0,1.2,4.69,3.63,3.63,0,0,0,4.61.43c-.41.87-.76,2.06,0,2.66a1.57,1.57,0,0,0,.65.28,3.5,3.5,0,0,0,2.05-.13,3.26,3.26,0,0,0-.86,2.87c.08.34,1.74,2.42,1.83,2.17,0,0,2.12-5.83,7.09-4.59s5,7.78,1.48,11.4S148.6,96,148.56,96c0,1-.12,6.69,4.52,10,2.85,2,10.33,2.43,14.28.06,1.46-2.6,3.9-5.93,5.78-8.85,6.31-9.78,8.39-15.8,7.29-21.31-.75-3.75-2.42-5.9-5.26-6.61-.15-3.57-.67-6.32-4.5-9.61-6-5.18-13-5.62-18.38-5.38a30.56,30.56,0,0,1-5.57.15c-1.59-.22-3.1-.88-4.68-1.16a4.91,4.91,0,0,0-4.5,1.07c-1.16,1.24-1.15,3.17-.73,4.81a8,8,0,0,0-3.71,1.07A4.4,4.4,0,0,0,131,63.26a3.07,3.07,0,0,0,1.76,3.17A5.52,5.52,0,0,0,131.25,67.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "155.473px 80.4013px"
    },
    id: "elj0rfpezdfwl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6ufh7qvee58"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "155.473px 80.4013px"
    },
    className: "animable",
    id: "el055tkeybellw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.25,67.83a5.32,5.32,0,0,0-1,2.69,4.59,4.59,0,0,0,2.1,4.23,4,4,0,0,0,4.62-.4,5.09,5.09,0,0,0,1.2,4.69,3.63,3.63,0,0,0,4.61.43c-.41.87-.76,2.06,0,2.66a1.57,1.57,0,0,0,.65.28,3.5,3.5,0,0,0,2.05-.13,3.26,3.26,0,0,0-.86,2.87c.08.34,1.74,2.42,1.83,2.17,0,0,2.12-5.83,7.09-4.59s5,7.78,1.48,11.4S148.6,96,148.56,96c0,1-.12,6.69,4.52,10,2.85,2,10.33,2.43,14.28.06,1.46-2.6,3.9-5.93,5.78-8.85,6.31-9.78,8.39-15.8,7.29-21.31-.75-3.75-2.42-5.9-5.26-6.61-.15-3.57-.67-6.32-4.5-9.61-6-5.18-13-5.62-18.38-5.38a30.56,30.56,0,0,1-5.57.15c-1.59-.22-3.1-.88-4.68-1.16a4.91,4.91,0,0,0-4.5,1.07c-1.16,1.24-1.15,3.17-.73,4.81a8,8,0,0,0-3.71,1.07A4.4,4.4,0,0,0,131,63.26a3.07,3.07,0,0,0,1.76,3.17A5.52,5.52,0,0,0,131.25,67.83Z",
    id: "el48zm5tc4mdp",
    className: "animable",
    style: {
      transformOrigin: "155.473px 80.4013px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M189.28,132.77c-1.14-11.13-7.08-14.91-9.21-16.11-3.39-.6-10.38-1-10.38-1,.06,1-3.33,3.59-11.15,4.25-6.3.53-10.86-.67-12.37-1.39-2.88,1.67-3.85,1.77-10.6,3.7-6.33,1.81-9.76,9.69-10.15,20.27-1.11,29.81-1.11,48.29-1.11,60.7,0,0,7.8,5.94,25.69,5.94,29.62,0,38-9.09,38-9.09-.84-12.11-1.3-19.52-1-26.68C187.6,162.24,191.05,150,189.28,132.77Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "157.045px 162.395px"
    },
    id: "elca95y8tvfpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellrzmqu7vzk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.28,132.77c-1.14-11.13-7.08-14.91-9.21-16.11-3.39-.6-10.38-1-10.38-1,.06,1-3.33,3.59-11.15,4.25-6.3.53-10.86-.67-12.37-1.39-2.88,1.67-3.85,1.77-10.6,3.7-6.33,1.81-9.76,9.69-10.15,20.27-1.11,29.81-1.11,48.29-1.11,60.7,0,0,7.8,5.94,25.69,5.94,29.62,0,38-9.09,38-9.09-.84-12.11-1.3-19.52-1-26.68C187.6,162.24,191.05,150,189.28,132.77Z",
    style: {
      opacity: 0.1,
      transformOrigin: "157.045px 162.395px"
    },
    className: "animable",
    id: "elaado01wd0w7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-8",
    d: "M134.77,123.18c8.31,5.43,3.87,35.56,2.38,50.89-.59,6.05-1.67,7.44-4.25,17.32-1.76,6.7-3.94,12.07-4.66,21-.39,4.71,1.21,10.31.43,15-.55,3.9.07,7.84.11,11.73.34,3,.86,6.41-.66,9.16a2.08,2.08,0,0,1-3.44.13c-.77-.88-.79-2.13-1.34-3.11a2.26,2.26,0,0,0-1.81-.87c-1.74-.28-2.56-2-3.32-3.42a1.4,1.4,0,0,0-1.25-.8c-3.33-1.15-4-5.92-4.53-9-2.47-10.75.08-21.81,1.75-32.5.63-4.65,2.18-13.64,3.53-24.78,0,0,1.53-26,1.7-33.06C119.66,131,124.44,123.75,134.77,123.18Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "125.538px 186.219px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,122.56c-6.41,1.32-10.9,2.28-14.14,8.83s-2.79,23.39-3,28.91-.59,11.69-.66,12.65-2.51,22-2.51,22a35.39,35.39,0,0,0,9.86,3.39c6,1.18,7.21,0,7.21,0s4.71-14.93,5.59-19.49,2.8-25.24,2.8-29.43S142.42,129.18,135.05,122.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "127.627px 160.712px"
    },
    id: "elfthis76qsip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.45,121c1.86-1.15,6-6.32,6.65-6.58,0,0,8.77,1.18,14.94.07s5.9-2.39,5.9-2.39.78-.39,1.7,1.27a9.45,9.45,0,0,0,2.58,2.58s-1.11,4-9.13,6.1-20.46-1.72-20.46-1.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "156.335px 117.37px"
    },
    id: "elw6ooaloezws",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-8",
    className: "animable",
    style: {
      transformOrigin: "72.1655px 250.511px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-8",
    className: "animable",
    style: {
      transformOrigin: "72.1655px 250.511px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-8",
    d: "M92.51,144.41c9.07,2.24,12.62,3,16.63,10.83s10.09,36.36,11.84,42.3,2.26,8.1,1.1,14.58c-1.21,6.75-5.8,18.64-7.8,25.18-.93,3-1.6,6-2.32,9.08s-2.31,6.16-3.5,9.27a8.91,8.91,0,0,1-2.85,3.69c-.8.62-1.83.64-2.59,1.22s-1,1.64-2,2.09-2.41.09-3.42.62a29,29,0,0,1-3.12,1.83,6.12,6.12,0,0,0-2.63,1.35c-.67.67-1.37,2.21-2.51,2S87.89,267,87.88,266a9.88,9.88,0,0,1,2.34-5.72c1.4-1.67,2.39-3.66,4-5.17a13.88,13.88,0,0,0,3-5.33c.47-1.31.43-3-1.33-2.33-2.08.82-4.32,2.65-6.73,2.11-1.67-.37-1.7-1.7-.66-2.76a49.68,49.68,0,0,0,4.7-5.61c1.46-2,2.7-4.16,4.21-6.13a30.27,30.27,0,0,1,2.64-2.91c2.59-2.57,2.67-6.24,3.12-9.63.62-4.74,1.12-9.49,1.58-14.24a8.45,8.45,0,0,0,.25-2.63L95,177.73Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "105.25px 206.44px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-8",
    className: "animable",
    style: {
      transformOrigin: "63.9358px 314.944px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2,369.78c0,2.46-.09,4.68,1.1,7.28,1.7,3.73,4.74,5.24,6.56,6.61a29.07,29.07,0,0,1,5.45,5.51,25.17,25.17,0,0,0,5.71,6c1.72,1.24,5.8,2.09,9.53,1.25,3-.67,4.39-2,3.94-5.45s-13.91-5.11-13.91-5.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "88.3857px 383.273px"
    },
    id: "el1q6a79e2biz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.85,380c.93.26.72,2.19.92,4.27.17,1.75,1.21,4.3.45,8.22-.59,1.16-2,1.91-4.18,2.29-3.11.53-8-.82-10.11-3.08-2.69-2.81-4.56-5.33-8.33-8.72-3.28-2.94-6.48-3.74-8.38-10-1.23-4.05-.71-5.82,2-7.25,3.66-2,10.13,2.81,13.19,3.38C91,369.54,101.92,379.71,102.85,380Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "88.5421px 380.071px"
    },
    id: "elbvpxcwb3eif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.39,377.5s-.38-7.65,9.83-9.64l.62.28a8.94,8.94,0,0,0-5.42-3.46c-3.51-.62-6.14.51-7.73,3S73.48,376.18,75.39,377.5Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "79.0045px 371.007px"
    },
    id: "el2k5gcwdj0bf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.37,369.05l-.52-.13a9.87,9.87,0,0,0-7.77,6.15c-.41,1.17,1.24,1.9,2.09.94,1.75-4.42,6-5.75,7.77-6.12A4.42,4.42,0,0,0,88.37,369.05Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "84.9778px 372.687px"
    },
    id: "el3ad831awywt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,370.77a9.78,9.78,0,0,0-7.18,6.05c-.41,1.17,1.23,1.9,2.09.95A10.11,10.11,0,0,1,92.34,372C91.88,371.57,91.44,371.14,91,370.77Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "88.0477px 374.488px"
    },
    id: "el6327fzlay38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2,368.43l-.44,13.28s-6.64,3.86-13.39.07c-.22-.39-1.32-6.76-1.32-6.76Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "95.625px 375.938px"
    },
    id: "el9p8tlg70cn8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.19,406.23a7.41,7.41,0,0,0-.1,3.92c.37.78,2.72,3.37,7.51,4.31s11.37,0,14.19-.17,11.73.91,14.56,1.3c4.44.6,7.86-.38,9.51-2a3,3,0,0,0,.67-2.34,11.64,11.64,0,0,0-.47-3.16Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "45.2162px 410.999px"
    },
    id: "eltib3crrhw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.32,403.45q.14.56.24,1.11a18.68,18.68,0,0,1,.41,5.77,5.26,5.26,0,0,1-3.41,2.58c-3.34,1.06-5.89.89-9.6.19a67.83,67.83,0,0,0-11.26-.7c-2.92.2-6.93.76-9.85.49a23.81,23.81,0,0,1-7.25-1.47c-1.94-.84-3.93-1.91-4.41-3.91-.57-4.22,1.2-6.08,3.21-7.26s4.83-1.09,7.87-1.29c2.75-.18,4.76-.19,7.2-.37a35,35,0,0,0,6.29-.88c1.84-.58,2.38-3.25,3.16-3.34,0,0,13.6.23,14.77.33,1.35.11,1.76,4.3,1.93,5.21.13.71.15,1.47.35,2.16C67.09,402.53,67.21,403,67.32,403.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "45.0592px 404.017px"
    },
    id: "elkwlnwf4tak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,412.33c-.38-3-.89-9.63,4.71-13.43l.71,0a13.94,13.94,0,0,0-7.74,0c-4.48,1.19-6.46,4.81-5.35,8.64C21.93,407.5,22.93,411.2,29.6,412.33Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "28.3237px 405.341px"
    },
    id: "elfjxhp7ng51a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.93,397.94c-1.81,1.6-2.43,5.25-2.43,5.25-.24,1.36-2.72,1.57-2.48.25a14.21,14.21,0,0,1,2.14-5.08A4.23,4.23,0,0,1,45.93,397.94Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "43.4668px 401.097px"
    },
    id: "elt6x87euf9y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.86,398.56a8.78,8.78,0,0,0-2.54,5c-.25,1.31-2.32,1.29-2.17,0,0,0,.24-3.24,2.17-4.75A2.77,2.77,0,0,1,40.86,398.56Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "38.5011px 401.448px"
    },
    id: "el1i1ujj1jo1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.41,365.47S64.9,393.64,65,395.42s-2,4.47-7.44,4.38c-3.82-.06-7.87-1.36-7.78-4.51l-1.91-21.66Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "57.14px 382.636px"
    },
    id: "el85ep2wjg3b6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.25,322.27a67.3,67.3,0,0,0-2.71-19.67s1.07-25.74,1.55-45.48c4.71-18.07.93-30.43-4-43,0,0-58.58,12.32-58.55,12.11-3.69,27.59-3.09,78.27-2.15,88s1.26,16.5,4,37.78c2.05,15.68,5.38,39,5.38,39,7.19,3.7,16.57.42,16.57.42s4.83-50.94,4.14-62.24c-.84-13.8-1.69-17.3-1.69-17.3s4.28-26.66,5.1-33.87c0,0,2.06,21.46,4.53,41.7C79.44,335.73,87.67,376,87.67,376a19.32,19.32,0,0,0,16-.83S105.25,333.48,105.25,322.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "72.4608px 303.445px"
    },
    id: "elh356mqzuiyf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmdzf3qpj8ia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.25,322.27a67.3,67.3,0,0,0-2.71-19.67s1.07-25.74,1.55-45.48c4.71-18.07.93-30.43-4-43,0,0-58.58,12.32-58.55,12.11-3.69,27.59-3.09,78.27-2.15,88s1.26,16.5,4,37.78c2.05,15.68,5.38,39,5.38,39,7.19,3.7,16.57.42,16.57.42s4.83-50.94,4.14-62.24c-.84-13.8-1.69-17.3-1.69-17.3s4.28-26.66,5.1-33.87c0,0,2.06,21.46,4.53,41.7C79.44,335.73,87.67,376,87.67,376a19.32,19.32,0,0,0,16-.83S105.25,333.48,105.25,322.27Z",
    style: {
      opacity: 0.1,
      transformOrigin: "72.4608px 303.445px"
    },
    className: "animable",
    id: "elisopoxdusc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4f7txelfa42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73,278.16l3-25A39.84,39.84,0,0,0,92.6,241.64s-.85,9.67-13.47,14.83l-3.29,20.47-.33,25.66Z",
    style: {
      opacity: 0.18,
      transformOrigin: "82.8px 272.12px"
    },
    className: "animable",
    id: "elpddnen4cjtp"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-8",
    className: "animable",
    style: {
      transformOrigin: "71.2312px 159.087px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.35,102.89c-1.63-1.88-1.64-4.88-.73-7.2s2.81-4.77,8.35-7.64c6.59-3.41,24.68-5.83,33.64,6C92.9,95.77,75.09,129.24,76,136.18c-4.62-4.85-19.87-21.93-19.87-21.93-3.61-1.54-5.79-2.84-6.56-6.25A8.43,8.43,0,0,1,50.35,102.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "70.3444px 110.717px"
    },
    id: "eliwegyu4bwj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.06,112.36s-4.88,8-4.34,8.63a25.16,25.16,0,0,0,3.61,2.39Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "50.8691px 117.87px"
    },
    id: "el96t8q5t4f0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.12,97.84c-3.27,1.54-6.11,4-7.13,11.24-.26,1.87,1.2,4.44.54,6.94-2.85,10.69.53,19.6,2.61,21.57,1.4,1.33,8.75,1.92,12.6.85C72.56,137.09,83,132.36,88,124.83c5.87-8.87,7.25-20.79.7-25.57C79.53,92.52,62.61,96.19,59.12,97.84Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "72.2377px 117.172px"
    },
    id: "eld2wgun3ipe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.17,129.88l1.91,13.21h0c2.94.63,3.22,4.12,1.76,6.76l.68,3.72-20.14,3.69L66.12,138.8Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "77.4101px 143.57px"
    },
    id: "elcsj6mnftfee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53,137.86c1.71.95,5.47,1.65,10.59.94l-.3-2.62a32.56,32.56,0,0,1-5,1.43A17.76,17.76,0,0,1,55.53,137.86Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "60.825px 137.635px"
    },
    id: "eleflvsuxytgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.28,101.67c-.18,4.66,2.74,6.12,4.82,7a10,10,0,0,0-.86,5.49c.47,2.36,1.37,4.29,3.69,5.07,1.42.48,1.84-.15,2.35-1.27.72-1.59,1.62-4,5-3.57,3.92.54,5,6.45,2.67,10.32a5.75,5.75,0,0,1-4.43,3,3.59,3.59,0,0,1-2.67-1.26s.26,5.16,6.9,8.22c0,0,6.69,3.76,13.55,1.74a130.86,130.86,0,0,0,8.73-10.75c7.24-10.46,8.69-29.61-3.65-33-.59-.16-11.76-1.73-17.2-.54C56.52,95.72,54.31,100.86,54.28,101.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "76.9215px 114.342px"
    },
    id: "elifdo13bw9q7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.91,153.89c-1.8-5.88-7.77-9-9.59-9.51s-6.24-1.29-6.24-1.29c1,2.33-.71,3.87-3.73,4.57-3.89.91-9.81,1-13.84-1.67l-1.65-1s-10.81,2.84-15,4.28c-.91.3-3.68,1.68-11.32,18.8-3.26,7.33-2.28,14.77,3.71,20,.33,4.64.76,14.47.76,14.47C42.47,218,41.59,225.8,41.59,225.8s1.6,7.22,30,7.12c22-.08,32.14-9.2,32.14-9.2-.26-5.41-6.9-19.7-6.07-26C99,188.41,107.42,171.84,101.91,153.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "71.2312px 188.006px"
    },
    id: "elsvxe4g1dzil",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-8",
    d: "M51.81,149.25c8.31,5.42,1.32,36.62-.17,51.94-.59,6.05-1.67,7.44-4.26,17.32-1.75,6.7-3.93,12.07-4.66,21-.38,4.71,1.22,10.31.43,15-.54,3.9.08,7.84.12,11.73.34,3,.85,6.41-.67,9.16a2.07,2.07,0,0,1-3.43.13c-.77-.87-.8-2.13-1.35-3.11a2.25,2.25,0,0,0-1.8-.87c-1.74-.28-2.57-2-3.32-3.41a1.38,1.38,0,0,0-1.25-.8c-3.33-1.16-4-5.93-4.53-9-2.47-10.75.08-21.81,1.75-32.5.63-4.65,2.18-13.64,3.53-24.78,0,0,2.07-26,2.93-33.06C36.62,155.82,39.35,152.58,51.81,149.25Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "40.8498px 212.814px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-8",
    className: "animable",
    style: {
      transformOrigin: "253.78px 392.593px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-8",
    className: "animable",
    style: {
      transformOrigin: "253.78px 392.593px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leaves--inject-8",
    className: "animable",
    style: {
      transformOrigin: "351.348px 392.563px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.37,380.3s2-7.48,11.18-13.06c7.38-4.47,12.38-3.89,12.71-3s-1.95,3.87-10.12,9C362.74,375.29,352.37,380.3,352.37,380.3Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "364.33px 371.96px"
    },
    id: "elnzcl5tdkrlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.86,393c.51-.73,7.08-6.36,15.47-10.08,4.46-2,7.33-1.67,7.34-.58,0,.64-2.31,3.63-9.1,6.62S340.35,393.72,340.86,393Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "352.253px 387.315px"
    },
    id: "el5xryy0aul7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.93,385.48c.65-.65,1.75-3.54,2.73-8.6.66-3.42,1.69-7.36.65-7.83S346.38,372,345.6,376,346.27,386.12,346.93,385.48Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "348.064px 377.267px"
    },
    id: "elpp1olxpky8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.67,398.3c.66-.82,1.45-6.87,1.79-9.65s.18-6.07-1-6.94-3.22,2.4-3.42,7.14S336,399.12,336.67,398.3Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "336.322px 389.976px"
    },
    id: "elpnjpeq14ps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.22,404.86c.11-.84,4.32-3.85,8.58-6.35s9.92-4.43,10-2.65-2.54,4.18-7.28,6.36C339.29,404.63,333.11,405.69,333.22,404.86Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "342.51px 400.154px"
    },
    id: "elivlaa73jgjn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.36,366.23a93.86,93.86,0,0,0-16.42,11.19,111,111,0,0,0-14,14.15,68.82,68.82,0,0,0-10.63,16.92,55.38,55.38,0,0,0-2.68,6.77c-.72,2.74-1.66,6.17-1,6.24a1.21,1.21,0,0,0,.6-.09c.37-.26.78-2.39,2-6.2a58.42,58.42,0,0,1,2.33-6.15,82.21,82.21,0,0,1,10.21-16.76A109.68,109.68,0,0,1,355.41,378a92.41,92.41,0,0,1,16-11.61.1.1,0,0,0,0-.1A.07.07,0,0,0,371.36,366.23Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "348.915px 393.868px"
    },
    id: "eldvrs715nphm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaves--inject-8",
    className: "animable",
    style: {
      transformOrigin: "359.61px 403.474px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.61,398.57s5.05-5.85,15.78-6.81c8.6-.76,12.84,1.95,12.76,2.86s-3.46,2.62-13,3.61C375.12,398.63,363.61,398.57,363.61,398.57Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "377.881px 395.1px"
    },
    id: "elldmyhy6peqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.69,404.92c.78-.43,9.15-2.6,18.32-2.25,4.88.19,7.32,1.73,6.85,2.71-.27.58-3.66,2.24-11.09,1.94S346.91,405.35,347.69,404.92Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "360.275px 404.994px"
    },
    id: "elsrygxiajdub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.44,400.83c.87-.29,3.13-2.41,6.24-6.52,2.1-2.78,4.75-5.86,4-6.74s-4.82.92-7.26,4.13S355.57,401.12,356.44,400.83Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "361.496px 394.094px"
    },
    id: "eln8gno4e87t9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.61,412.21c.46-.7,5.58-1.55,10.5-1.93s10.86.39,10.17,2-4.12,2.63-9.34,2.5C341.16,414.68,335.14,412.91,335.61,412.21Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "345.96px 412.488px"
    },
    id: "el5drfw1oxwor",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.85,394.29a92.9,92.9,0,0,0-19.67,2.84,109.46,109.46,0,0,0-18.82,6.53,68.94,68.94,0,0,0-17,10.52c-.87.77-1.77,1.5-2.65,2.26a5.27,5.27,0,0,0-1.09,1.07,3.25,3.25,0,0,0-.51,1.23,1,1,0,0,0,0,.57.5.5,0,0,0,.42.29c.17,0,.29-.21.41-.32q.48-.5,1-1c.66-.65,1.34-1.28,2-1.9q.63-.57,1.29-1.11a82.13,82.13,0,0,1,16.54-10.57,109.25,109.25,0,0,1,18.52-6.89,93.28,93.28,0,0,1,19.49-3.39.07.07,0,0,0,.07-.07A.08.08,0,0,0,386.85,394.29Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "356.962px 406.945px"
    },
    id: "ellgwlll8uwo",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaves--inject-8",
    className: "animable",
    style: {
      transformOrigin: "156.172px 392.904px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155,380.64s-2.07-7.45-11.35-12.9c-7.45-4.38-12.44-3.73-12.76-2.88s2,3.85,10.24,8.84C144.55,375.77,155,380.64,155,380.64Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "142.931px 372.441px"
    },
    id: "elrxkbct8nmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.66,393.19c-.52-.72-7.16-6.27-15.59-9.87-4.5-1.92-7.36-1.57-7.36-.48,0,.64,2.36,3.59,9.19,6.5S167.18,393.91,166.66,393.19Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "155.198px 387.654px"
    },
    id: "el7ezpr48t60c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5,385.75c-.66-.64-1.8-3.52-2.85-8.56-.7-3.41-1.79-7.33-.75-7.82s4,2.9,4.8,6.85S161.16,386.39,160.5,385.75Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "159.209px 377.559px"
    },
    id: "el00vvom0pgg8bf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.92,398.43c-.67-.81-1.54-6.84-1.92-9.62s-.26-6.07.91-6.95,3.24,2.36,3.51,7.09S171.59,399.25,170.92,398.43Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "171.125px 390.113px"
    },
    id: "el8a6shct954r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.46,404.94c-.11-.83-4.37-3.78-8.66-6.23s-10-4.3-10.07-2.51,2.6,4.14,7.37,6.26C168.39,404.8,174.58,405.78,174.46,404.94Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "165.095px 400.361px"
    },
    id: "elndtu1p8hs8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.81,366.83a93.5,93.5,0,0,1,16.57,11,110.32,110.32,0,0,1,14.21,14,68.33,68.33,0,0,1,10.86,16.77,55.36,55.36,0,0,1,2.77,6.73c.76,2.73,1.74,6.15,1,6.23a1.35,1.35,0,0,1-.6-.08c-.37-.25-.81-2.38-2.1-6.18a58.34,58.34,0,0,0-2.42-6.11A81.3,81.3,0,0,0,165.7,392.5a109,109,0,0,0-13.79-14.14A93,93,0,0,0,135.75,367a.07.07,0,0,1,0-.1A.06.06,0,0,1,135.81,366.83Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "158.606px 394.198px"
    },
    id: "el3q7a2lbyus7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaves--inject-8",
    className: "animable",
    style: {
      transformOrigin: "148.101px 403.738px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144,399.06s-5.13-5.77-15.87-6.59c-8.61-.66-12.81,2.12-12.72,3s3.5,2.57,13.08,3.42C132.48,399.28,144,399.06,144,399.06Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "129.704px 395.746px"
    },
    id: "elmaw4my8rny",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,405.2c-.78-.42-9.18-2.48-18.34-2-4.89.26-7.3,1.83-6.82,2.81.28.57,3.7,2.19,11.11,1.79S160.78,405.62,160,405.2Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "147.418px 405.495px"
    },
    id: "el6vhgp3telzk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,401.23c-.88-.28-3.17-2.37-6.32-6.44-2.14-2.75-4.84-5.79-4.12-6.69s4.84.86,7.32,4S152.06,401.51,151.19,401.23Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "146.035px 394.552px"
    },
    id: "elysibp432w1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.17,412.33c-.47-.7-5.6-1.48-10.52-1.79s-10.86.53-10.15,2.17,4.16,2.58,9.37,2.38C166.65,414.87,172.65,413,172.17,412.33Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "161.819px 412.797px"
    },
    id: "elwr047wknvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.69,395.09a93,93,0,0,1,19.71,2.58A109.68,109.68,0,0,1,159.3,404a68.63,68.63,0,0,1,17.13,10.29c.89.76,1.8,1.48,2.69,2.23a5.23,5.23,0,0,1,1.1,1,3.31,3.31,0,0,1,.53,1.22,1,1,0,0,1,0,.58.5.5,0,0,1-.42.29c-.17,0-.3-.2-.41-.31l-1-1c-.67-.64-1.36-1.27-2.06-1.88-.43-.37-.87-.73-1.31-1.09A82,82,0,0,0,158.83,405a109.24,109.24,0,0,0-18.6-6.64,92.38,92.38,0,0,0-19.54-3.13.08.08,0,0,1-.07-.08A.08.08,0,0,1,120.69,395.09Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "150.706px 407.35px"
    },
    id: "el2wiwlgkic6f",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8",
    className: "animable",
    style: {
      transformOrigin: "255.02px 424.85px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-8",
    cx: 255.02,
    cy: 424.85,
    rx: 78.09,
    ry: 45.09,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "255.02px 424.85px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-8",
    className: "animable",
    style: {
      transformOrigin: "253.52px 237.352px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-8",
    className: "animable",
    style: {
      transformOrigin: "253.52px 237.352px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-8",
    className: "animable",
    style: {
      transformOrigin: "262.576px 332.472px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.65,389.48c.21-5.46,3.25-65.75,3.25-65.75l-26.67,19.9c4.16,31.46,5.9,45.93,6.2,51.17h0a4.32,4.32,0,0,0-.09,1.35c.26,6.22,7.52,9.32,13.25,13.27A104,104,0,0,0,297,418.55c4.12,1.85,12.34,1.74,13.26-.86-7-4.85-15-10.13-20.63-15.75C287,399.26,285.39,396,285.65,389.48Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "286.245px 371.769px"
    },
    id: "ela1dql617h5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.39,424.05c.33,0,.95,3.74-.75,5.41-2,1.92-7.83,5.18-15.76,4.4s-12.3-3.2-15.56-5.87-7.83-6.43-11.43-7.13c-3.35-.64-7-2.09-8.11-3.13s-1.13-5.85-1.13-5.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "292.214px 422.929px"
    },
    id: "eln9fda7b599",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,393.28s-.86,0-1,1.11c-.19,1.33-.42,5.21-.86,7.4-.62,3-1.1,9.29-.58,11.74s6,4,9.5,5.21,7.77,4.05,11.47,7,11.75,6,16.89,5.91c7.86-.17,12.86-2.6,14.32-5.63,1.81-3.75,1.12-6.34-8.07-10.41a106.08,106.08,0,0,1-10.24-5.85,31,31,0,0,1-11.89-14.18,3.56,3.56,0,0,0-1.37-1.94,2.78,2.78,0,0,0-1.76-.1c-1.49.28-5.82,1-7.17,1.75-1.18.65-2.88,1.42-2.79,3.06a5.87,5.87,0,0,0,.4,1.64c.12.33.22.77,0,1s-.61,0-.85-.21a25.29,25.29,0,0,1-2.55-3,9,9,0,0,0-1.48-1.48,15.06,15.06,0,0,1-1.58-1A20.27,20.27,0,0,1,268.33,393.28Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "292.27px 412.466px"
    },
    id: "elfsos6kbnr5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.23,415.63c-11.34,1.25-16.08,9-14.64,14.57a25.53,25.53,0,0,0,8.13,1.48c7.86-.17,13.19-2.61,14.65-5.64C320.07,422.5,318.41,418.56,310.23,415.63Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "307.155px 423.655px"
    },
    id: "elxi5aee2sp1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.79,417.33a.51.51,0,0,1-.35-.11.61.61,0,0,1-.11-.83c1.5-2.1,6-5,10.12-4.65a.59.59,0,0,1,.52.63.56.56,0,0,1-.6.54c-3.87-.29-8,2.53-9.16,4.19A.51.51,0,0,1,294.79,417.33Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "299.593px 414.521px"
    },
    id: "elby0nzmy1fzk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,414.47a.6.6,0,0,1-.36-.12.62.62,0,0,1-.11-.82c1.51-2.1,6-5,10.12-4.65a.57.57,0,0,1,.52.62.55.55,0,0,1-.59.54c-3.87-.29-8,2.53-9.16,4.2A.56.56,0,0,1,290.21,414.47Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "295.008px 411.661px"
    },
    id: "elt4d2433bc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.68,410.8a.54.54,0,0,1-.36-.12.62.62,0,0,1-.11-.82c1.51-2.1,6-5,10.12-4.65a.57.57,0,0,1,.52.62.56.56,0,0,1-.59.55c-3.87-.29-8,2.52-9.16,4.19A.56.56,0,0,1,285.68,410.8Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "290.478px 407.991px"
    },
    id: "eldoyek9wpy6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,407.11a.52.52,0,0,1-.35-.11.61.61,0,0,1-.12-.82c2.07-3,6.92-5.07,11.07-4.74a.58.58,0,0,1-.08,1.16c-3.73-.28-8.25,1.64-10.09,4.28A.51.51,0,0,1,281.2,407.11Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "286.481px 404.258px"
    },
    id: "ele361hzn9dhn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,346.78l-26.3-5.51c-.9,16.48-.48,43.38-.46,58.6,0,2.92-1.86,22.58-1.13,28.64,1.1,9.1,12.87,8.68,13.91,3.34s2.2-28.18,2.42-30.54a15.12,15.12,0,0,1,.23-2.12C231.57,385.31,239.81,347.57,240,346.78Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "225.97px 388.46px"
    },
    id: "elcqs1hgq30hw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.12,435.89c-.17,5.3-1,8.82-2.92,12s-5.8,4.21-9.75,3.4-9.06-3.12-10.32-7.65S206,436,206.73,431Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.15px 441.277px"
    },
    id: "eliq6gew2q17d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.23,398.19c-1.62.16-1.79,7.06-2.5,14.19-.76,7.64-3.15,10.85-3.85,17.12-.8,7.17-.29,10.34,2.58,14.59s12.7,8.25,17.28,2c3.74-5.13,3.73-10.72,3.15-17.84a163.22,163.22,0,0,1-.92-18.13c.15-5.35,1.1-10.33-.32-10.89-.08.79-.16,1.79-.25,2.56-.07.6-.14,3.49-1.05,3.54a11.2,11.2,0,0,1-.08-2,2.23,2.23,0,0,0-.49-1.71,6,6,0,0,0-2.53-.91c-1.6-.25-3.21-.47-4.83-.56q-1.21-.07-2.43,0a7.06,7.06,0,0,0-2,.31,1.39,1.39,0,0,0-.85.75,2,2,0,0,0-.06.82,5.66,5.66,0,0,1-.16,1.47c0,.21-.2.47-.43.42s-.27-.25-.28-.42c0-.86.07-1.49.08-2.5,0-.46,0-.9,0-1.36S213.21,398.65,213.23,398.19Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "218.356px 423.757px"
    },
    id: "eldgvluywdt89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,433.65c-.14,4.44.23,7.47,2.48,10.79,2.87,4.25,13.48,8.25,18.06,1.95,2.28-3.13,2.81-6.79,3-10.5C227.11,431.19,211,429.49,206.56,433.65Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "218.317px 440.475px"
    },
    id: "elq87318tvxdo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.73,428.23a.65.65,0,0,1-.2-.05,25.79,25.79,0,0,0-14-1,.61.61,0,0,1-.73-.4.55.55,0,0,1,.43-.67,26.64,26.64,0,0,1,14.77,1,.53.53,0,0,1,.31.72A.63.63,0,0,1,225.73,428.23Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "218.571px 426.866px"
    },
    id: "elhktbx78tgaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.77,421.88a.6.6,0,0,1-.52-.36.53.53,0,0,1,.35-.7c7.18-2.42,14.45.77,14.75.91a.53.53,0,0,1,.28.73.63.63,0,0,1-.8.25c-.07,0-7.13-3.12-13.81-.87A.73.73,0,0,1,211.77,421.88Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "218.95px 421.341px"
    },
    id: "el2ppc6ktxrp9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,416.85a.58.58,0,0,1-.52-.35.53.53,0,0,1,.34-.71,20.17,20.17,0,0,1,15.05.87.52.52,0,0,1,.22.74.63.63,0,0,1-.82.21,19.16,19.16,0,0,0-14-.8A.49.49,0,0,1,212,416.85Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "219.303px 416.208px"
    },
    id: "elw4brcd343t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.34,411.2a.59.59,0,0,1-.51-.34.52.52,0,0,1,.33-.71c7.39-2.74,14.84.86,15.16,1a.52.52,0,0,1,.24.74.62.62,0,0,1-.81.22c-.07,0-7.28-3.5-14.14-1A.51.51,0,0,1,212.34,411.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "219.709px 410.652px"
    },
    id: "el45e3jx3d7y4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.09,214.08c-1.64,31.08-4.51,94.09-4.51,94.09-.36,3.61-3.56,19.6-3.89,32.66-.52,20.95.29,40.35.29,40.35s11.61,5.13,19.66,1.82c0,0,10.62-47.38,13.31-61,3.2-16.26,10-48.63,10-48.63l5.37,43s-1.68,15.29,0,27.93c1.15,8.61,5.44,37.26,5.44,37.26s10.71,2.37,19.47-.52c0,0,4.1-60.86,4.62-68.8s2-48.77.12-98.85Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "252.206px 298.751px"
    },
    id: "el379pa2bukyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.66,375.34c-4.31,3.26-16,3.1-20.9.43l1.48,9c3.52,2.1,13.84,2.51,19-1.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "276.21px 380.851px"
    },
    id: "el1k2eydudh9z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,377.7c-6.09,2.77-17.6,1.14-21.21-2.36v8.77c2.84,2.95,13.79,4.37,19.59,2.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "223.395px 381.338px"
    },
    id: "elhn4i20brjla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,273.34l4.47-27.83a23.61,23.61,0,0,0,15.05-6.67s-.69,6.41-12.68,10.53l-4.1,23.09,2.63,43.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.76px 277.57px"
    },
    id: "el17pjl9cjqht",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-8",
    className: "animable",
    style: {
      transformOrigin: "253.52px 153.415px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fist--inject-8",
    className: "animable",
    style: {
      transformOrigin: "307.505px 54.4857px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.4,50.32A3.82,3.82,0,0,1,315.47,48a12.53,12.53,0,0,0,1.33-1.78c1.93-3,1.24-6.13,2.14-8.87-7.22-2.23-12-2.08-15.16.7l-7.5-.38c-.77,2.07-.09,3.76,1.25,7.95.8,2.48,1.14,2.87,1.21,3.87a23.19,23.19,0,0,1-.24,4.75h0c-.71,5.83-3.9,26.95-3.9,26.95-.06,1.17,1.11,2.15,2.67,3a22.45,22.45,0,0,0,7.49,1.6,23.26,23.26,0,0,0,7.55-.85c1.69-.58,2.9-1.57,3-2.74,0,0-.85-26.6-.9-28.38C314.32,51.9,314.35,51.55,314.4,50.32Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "306.769px 60.8145px"
    },
    id: "el39b0qw5w4zp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.22,40.75c1.69,2.27,1.7,6.58.51,8.28,3.82-3.54.49-9.68.49-9.68a5.08,5.08,0,0,0,3.61.5c1.5,1.52,2.67,1.41,3.62,1a6,6,0,0,0,2.25-2.6c.07-.3.15-.6.24-.89a40.43,40.43,0,0,0-4.28-1.1c-4.81-.84-8.49-.31-10.88,1.8A7.34,7.34,0,0,1,308.22,40.75Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "311.36px 42.4548px"
    },
    id: "elidtex3tfi5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51,28.33c1.8.24,2.22.26,3.33,2.1a10.5,10.5,0,0,1,1.51,3.6c.23.86-.2,1.44-.79,2.39a18.65,18.65,0,0,1-2.5,3.28,2,2,0,0,1-2.62.34,13.68,13.68,0,0,1-1.55-1.42Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "316.652px 34.3554px"
    },
    id: "elp7y8t3p45j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.48,39.49c-.38-.51-.32-1.05.32-2a22.33,22.33,0,0,0,2.44-4.48c.23-.94-1.19-3.37-2.08-4.63l-.65-.09-2.62,10.29A13.68,13.68,0,0,0,314.44,40a2,2,0,0,0,2.62-.34c.1-.1.21-.21.31-.33C316.65,39.89,315.83,40,315.48,39.49Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "315.577px 34.3154px"
    },
    id: "elfxyq13q568r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.56,36.42a17,17,0,0,1-1.23,1.93,10.26,10.26,0,0,1-.71.89,6.35,6.35,0,0,1-.83.81,2.22,2.22,0,0,1-1.1.42,1.79,1.79,0,0,1-1.15-.27,9.88,9.88,0,0,1-1.65-1.58c.28.26.56.52.84.76a7.09,7.09,0,0,0,.89.69,1.76,1.76,0,0,0,1.05.22,2.08,2.08,0,0,0,1-.4,4.9,4.9,0,0,0,.81-.77c.26-.28.49-.57.73-.86s.47-.6.69-.91S319.34,36.73,319.56,36.42Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "316.225px 38.45px"
    },
    id: "elha8zay3vz9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el49jiur4cy9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.56,36.42a17,17,0,0,1-1.23,1.93,10.26,10.26,0,0,1-.71.89,6.35,6.35,0,0,1-.83.81,2.22,2.22,0,0,1-1.1.42,1.79,1.79,0,0,1-1.15-.27,9.88,9.88,0,0,1-1.65-1.58c.28.26.56.52.84.76a7.09,7.09,0,0,0,.89.69,1.76,1.76,0,0,0,1.05.22,2.08,2.08,0,0,0,1-.4,4.9,4.9,0,0,0,.81-.77c.26-.28.49-.57.73-.86s.47-.6.69-.91S319.34,36.73,319.56,36.42Z",
    style: {
      opacity: 0.2,
      transformOrigin: "316.225px 38.45px"
    },
    className: "animable",
    id: "elxzawvxvvydj"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.34,29a3.19,3.19,0,0,1,1.14.17,4.68,4.68,0,0,1,.48.18l.16.07a3,3,0,0,0-.5-.47l-.2-.06a2,2,0,0,0-1.08.08S316.32,29,316.34,29Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "317.226px 29.135px"
    },
    id: "eltrw0yd0plcc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.8,29.58l.1,0,0,0,0,0a0,0,0,0,0,0-.06s0,0-.07-.06l-.1,0-.2-.05-.2,0h-.23s0,0,0,0l.09,0,.1,0,.21.05Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "317.5px 29.495px"
    },
    id: "elphriezh778h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.37,26.19A3.62,3.62,0,0,1,315,27.53a26.11,26.11,0,0,1,2.29,3.74,2.88,2.88,0,0,1-.49,2.85c-.84,1.36-2.36,3.8-3.62,4.4a3.24,3.24,0,0,1-3.57-.66Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "313.54px 32.4506px"
    },
    id: "elea5acg5zzwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.32,33.05a4.23,4.23,0,0,0,.52-2.75,22.76,22.76,0,0,0-1.8-4.14c-.24,0-.46,0-.67,0l-1.81,11.67a3.24,3.24,0,0,0,3.57.66,2.88,2.88,0,0,0,.52-.34,2.15,2.15,0,0,1-1.87-.09c-.45-.31-.61-.68-.21-1.43S312.68,34.53,313.32,33.05Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "311.724px 32.4605px"
    },
    id: "elpe7n7i9dxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.75,34.12a23.07,23.07,0,0,1-1.25,2.06c-.22.33-.46.65-.71,1A9.82,9.82,0,0,1,314,38a3,3,0,0,1-2.25.84,2.94,2.94,0,0,1-1.16-.34,5.68,5.68,0,0,1-1-.68,5.35,5.35,0,0,0,1,.59,3,3,0,0,0,1.13.28,3,3,0,0,0,1.14-.2,3,3,0,0,0,1-.64,11.59,11.59,0,0,0,1.55-1.8c.24-.32.47-.65.69-1Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "313.17px 36.4822px"
    },
    id: "elol2dtqu4ys9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2pe2d6kgpc8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.75,34.12a23.07,23.07,0,0,1-1.25,2.06c-.22.33-.46.65-.71,1A9.82,9.82,0,0,1,314,38a3,3,0,0,1-2.25.84,2.94,2.94,0,0,1-1.16-.34,5.68,5.68,0,0,1-1-.68,5.35,5.35,0,0,0,1,.59,3,3,0,0,0,1.13.28,3,3,0,0,0,1.14-.2,3,3,0,0,0,1-.64,11.59,11.59,0,0,0,1.55-1.8c.24-.32.47-.65.69-1Z",
    style: {
      opacity: 0.2,
      transformOrigin: "313.17px 36.4822px"
    },
    className: "animable",
    id: "eluzbe0cdc8j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.09,27a1.83,1.83,0,0,0-.32-.07,1.78,1.78,0,0,0-.65,0s0,0,0,0a4,4,0,0,1,.67.14l.31.09a1.19,1.19,0,0,0,.32.1c.08,0,.07-.15,0-.18A1.28,1.28,0,0,0,314.09,27Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "313.798px 27.08px"
    },
    id: "el6pyt7cm45fi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,26.61l.49.11a3.06,3.06,0,0,0-.65-.33,2.16,2.16,0,0,0-1.12.21h0A3.93,3.93,0,0,1,313.64,26.61Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "313.245px 26.5514px"
    },
    id: "elhz4gddloqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,27.64a.44.44,0,0,0-.08-.11.76.76,0,0,0-.08-.11,3,3,0,0,1-.84,0,10.74,10.74,0,0,1-1.26-.23s0,0,.07.08a2.91,2.91,0,0,0,1.19.37A2.76,2.76,0,0,0,315,27.64Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "313.87px 27.4378px"
    },
    id: "elryo5zx50fd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43,24.34c1.5-.09,2.76,0,3.42.89a21.68,21.68,0,0,1,2.2,4.42c.28,1,.46,1.3-.4,3.47s-2.26,4.24-3.08,4.73-3.24.71-3.75-.53S307.43,24.34,307.43,24.34Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "309.511px 31.2758px"
    },
    id: "elfnoiwzl2f1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.85,29.36a12.3,12.3,0,0,0-.77-5.05l-.65,0s-2.13,11.75-1.61,13,2.47,1,3.46.67c-1.3.17-1.94-.41-2.07-.94s.62-1.3.62-1.3a12.28,12.28,0,0,0,2.49-1.57,3.21,3.21,0,0,0,.86-2.63C311.41,29.67,310.81,29.5,308.85,29.36Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "308.482px 31.2792px"
    },
    id: "el0lb1ohz5ifzc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.65,33.12a11.42,11.42,0,0,1-.45,1.15c-.17.38-.35.75-.55,1.11a10.89,10.89,0,0,1-1.42,2,3.87,3.87,0,0,1-.47.43,2.16,2.16,0,0,1-.57.28,4.4,4.4,0,0,1-1.24.2,3.63,3.63,0,0,1-1.23-.18,1.47,1.47,0,0,1-.9-.82,1.41,1.41,0,0,0,.93.72,3.4,3.4,0,0,0,1.19.12,5.2,5.2,0,0,0,1.19-.21,2,2,0,0,0,.52-.27,3.32,3.32,0,0,0,.43-.41,11.14,11.14,0,0,0,1.43-2A19.62,19.62,0,0,0,312.65,33.12Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "309.235px 35.7057px"
    },
    id: "el1advoh3dtu6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbhnqbvf00mk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.65,33.12a11.42,11.42,0,0,1-.45,1.15c-.17.38-.35.75-.55,1.11a10.89,10.89,0,0,1-1.42,2,3.87,3.87,0,0,1-.47.43,2.16,2.16,0,0,1-.57.28,4.4,4.4,0,0,1-1.24.2,3.63,3.63,0,0,1-1.23-.18,1.47,1.47,0,0,1-.9-.82,1.41,1.41,0,0,0,.93.72,3.4,3.4,0,0,0,1.19.12,5.2,5.2,0,0,0,1.19-.21,2,2,0,0,0,.52-.27,3.32,3.32,0,0,0,.43-.41,11.14,11.14,0,0,0,1.43-2A19.62,19.62,0,0,0,312.65,33.12Z",
    style: {
      opacity: 0.2,
      transformOrigin: "309.235px 35.7057px"
    },
    className: "animable",
    id: "elaxd9vg3ikzu"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.85,25.49a3.7,3.7,0,0,0-.47,0l-.53,0c-.34,0-.68-.06-1-.07a0,0,0,0,0,0,0,6,6,0,0,0,1,.25,4.36,4.36,0,0,0,.51,0,1.34,1.34,0,0,0,.49,0C310.93,25.64,310.93,25.5,310.85,25.49Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "309.88px 25.5563px"
    },
    id: "eln2hsjyfpb3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.85,24.92A1.86,1.86,0,0,0,309,25s0,0,0,0a4.07,4.07,0,0,1,.78,0,2.57,2.57,0,0,1,.38.08l.19.06a.52.52,0,0,0,.16.06c.07,0,.08-.12,0-.16a1.16,1.16,0,0,0-.37-.13A2.38,2.38,0,0,0,309.85,24.92Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "309.783px 25.0512px"
    },
    id: "el8002jh8fqmt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.19,24.66a3.13,3.13,0,0,0-.73-.25,2.35,2.35,0,0,0-1.45.47s0,.06,0,0a3.24,3.24,0,0,1,1.6-.29A5.63,5.63,0,0,1,310.19,24.66Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "309.1px 24.6582px"
    },
    id: "eld8wto1ddx6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.88,36.11a63.8,63.8,0,0,1,0-7.31,3.64,3.64,0,0,1,1.84-2.6,39.5,39.5,0,0,1,5.24-2.91c1-.36,3.09.09,3.49,1.2.55,1.55.7,6.26.56,8.29a6.08,6.08,0,0,1-1.51,4,5.89,5.89,0,0,1-2.69,1.26Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "302.417px 30.6042px"
    },
    id: "elq14yeyl2eyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,29.32a36.67,36.67,0,0,1-5.77.27c-1.89-.07-2.94.05-3.63,1a8.6,8.6,0,0,0-1.08,1.9c-.22.52-.52.23-.76-.91,0,1.49.07,3.23.12,4.53l6.9,2a5.89,5.89,0,0,0,2.69-1.26,6.08,6.08,0,0,0,1.51-4C308,32,308.05,30.66,308,29.32Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "302.391px 33.715px"
    },
    id: "elr5zidor05af",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.78,38.08a9.06,9.06,0,0,0,.88-.29,7.91,7.91,0,0,0,.84-.37,4.23,4.23,0,0,0,.74-.51,4.38,4.38,0,0,0,.59-.69,5.7,5.7,0,0,0,.78-1.63,8.89,8.89,0,0,0,.22-.89c.06-.31.1-.61.15-.92a8.28,8.28,0,0,1-.22,1.85,5,5,0,0,1-.77,1.71,4.64,4.64,0,0,1-.62.71,4,4,0,0,1-.8.51A6.67,6.67,0,0,1,303.78,38.08Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "305.88px 35.43px"
    },
    id: "eluriceljeym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele5xj2wj53ww"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.78,38.08a9.06,9.06,0,0,0,.88-.29,7.91,7.91,0,0,0,.84-.37,4.23,4.23,0,0,0,.74-.51,4.38,4.38,0,0,0,.59-.69,5.7,5.7,0,0,0,.78-1.63,8.89,8.89,0,0,0,.22-.89c.06-.31.1-.61.15-.92a8.28,8.28,0,0,1-.22,1.85,5,5,0,0,1-.77,1.71,4.64,4.64,0,0,1-.62.71,4,4,0,0,1-.8.51A6.67,6.67,0,0,1,303.78,38.08Z",
    style: {
      opacity: 0.2,
      transformOrigin: "305.88px 35.43px"
    },
    className: "animable",
    id: "ellb9a4lbwb5d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.91,23.38l.17,0a4.3,4.3,0,0,0-1.26-.23,2.26,2.26,0,0,0-.74.34,1.76,1.76,0,0,0-.59.68s0,0,0,0a2.54,2.54,0,0,1,1.42-.76A4.57,4.57,0,0,1,305.91,23.38Zm-.76.51a2.53,2.53,0,0,0-.55.18s0,0,0,0c.2,0,.4,0,.59,0l.58,0a9.89,9.89,0,0,1,1.09.17c.17,0,.12-.26,0-.28a8.9,8.9,0,0,0-1.14-.15A3.5,3.5,0,0,0,305.15,23.89Zm2,.94a1.34,1.34,0,0,0-.63,0,5.18,5.18,0,0,1-.79,0,8.6,8.6,0,0,1-1.33-.23s0,0,0,0a4,4,0,0,0,1.39.47c.22,0,.45,0,.67,0a1.06,1.06,0,0,0,.68-.15S307.15,24.84,307.12,24.83Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "305.32px 24.1137px"
    },
    id: "elizomel1r1df",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,29.6a2.84,2.84,0,0,1,.47-2.9,2.28,2.28,0,0,0-1.26,1.73,10.42,10.42,0,0,0-.1,1.74Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "302.288px 28.435px"
    },
    id: "eli23djdz8v39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.22,29.59a23.15,23.15,0,0,0-3.05.49c-1,.19-2.29.19-4.61.53a3.79,3.79,0,0,0-2.72,1.46c-.82.91-1.26,2.16-2.56,5.63l7.5.38.61-2.07A19.52,19.52,0,0,0,308,35c1.95-.83,3-2.22,3.14-3.33S311.19,29.45,309.22,29.59Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "303.732px 33.829px"
    },
    id: "elrzdz2ukuh3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39,36a2.41,2.41,0,0,0-.81-2.34,1.93,1.93,0,0,1,1.33,2.23Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "304.264px 34.83px"
    },
    id: "el5vx5noocrxs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.78,38.08l.27-1c.09-.34.18-.69.28-1v0h0c.39-.08.77-.18,1.16-.28s.77-.2,1.15-.32.75-.26,1.12-.41a8.08,8.08,0,0,0,1.07-.51,5.58,5.58,0,0,0,1.75-1.56,3,3,0,0,0,.49-1.07,5.61,5.61,0,0,0,.06-.59,2.41,2.41,0,0,0,0-.6,2,2,0,0,1,.06.6c0,.2,0,.4,0,.61a3,3,0,0,1-.45,1.12A5.5,5.5,0,0,1,309,34.59a9.92,9.92,0,0,1-2.23.93,17.27,17.27,0,0,1-2.34.55l.05,0-.33,1C304,37.4,303.9,37.74,303.78,38.08Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "307.486px 34.41px"
    },
    id: "el4j4u7x5bqlw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell9r58xwr7cm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.78,38.08l.27-1c.09-.34.18-.69.28-1v0h0c.39-.08.77-.18,1.16-.28s.77-.2,1.15-.32.75-.26,1.12-.41a8.08,8.08,0,0,0,1.07-.51,5.58,5.58,0,0,0,1.75-1.56,3,3,0,0,0,.49-1.07,5.61,5.61,0,0,0,.06-.59,2.41,2.41,0,0,0,0-.6,2,2,0,0,1,.06.6c0,.2,0,.4,0,.61a3,3,0,0,1-.45,1.12A5.5,5.5,0,0,1,309,34.59a9.92,9.92,0,0,1-2.23.93,17.27,17.27,0,0,1-2.34.55l.05,0-.33,1C304,37.4,303.9,37.74,303.78,38.08Z",
    style: {
      opacity: 0.2,
      transformOrigin: "307.486px 34.41px"
    },
    className: "animable",
    id: "elybkgau84ux9"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M273.21,127.17a82.12,82.12,0,0,1,8-8.23c3.39-3.18,11.56-25.54,11.56-25.54l5-33.56c2.62,2.73,13.66,3.81,17.86,1.51,0,0-.07,12.37-.41,32.29-.12,7.13-.37,9-5.37,21.58-2.87,7.2-4.52,11.2-9,20.68-4,8.33-10.74,21.84-12,27.73-.33,1.58-.33,3.71-2.49,3.75-3.33.07-6.33-10.95-8.66-15.65C273.2,142.79,272.68,131.26,273.21,127.17Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "294.336px 113.61px"
    },
    id: "ellqzzroga25b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.76,57.82l-1,7.4s1.56,2.53,9.12,3.17,9.7-.82,9.7-.82V60s-1.68,1.22-8.81.51S297.76,57.82,297.76,57.82Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "306.17px 63.1861px"
    },
    id: "el5zbdkbc84v8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-8",
    d: "M242.11,128.1c-11,2.45-14.26,3.51-19.44,4.71,0,0-9.16,12.18-5.25,45.88.51,4.46,3.4,17.21,3.39,25.21,0,7.65-.07,10.84-.72,23,0,0,14.84,9.65,45.5,6.53,24.08-2.46,25.76-10.93,25.76-10.93s-1.33-33.14-1.9-50.84c-.57-18-1.63-25.4-6.16-34.36-1.87-3.69-6.14-8.67-10.08-10.12a97.42,97.42,0,0,1-10.65,1.27Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "253.899px 180.616px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,151.49c-.06-.18,1.1-3.73.74-7a11.94,11.94,0,0,0,1.94-7.61,34.15,34.15,0,0,1-3-2.08l-1.5,10.25-4.64,1.6s-12.82-8.61-14.15-9.84l-3.81,2.71c2.12,3.29,6.78,6.78,14.14,8.19a6.35,6.35,0,0,0,4.62,5.43c4.27,5.8,5.76,12.24,3.89,19.29-2.3,8.65-6.88,13.14-16.4,20.39-6.38,4.87-10.16,8.57-13.13,18.84l4.19,12,16.07-8.51c1.18-4.46,3.48-7.78,9.05-14.66,8.08-10,8.52-17.65,8.38-24.71C272.52,164.58,268.51,155,266.33,151.49Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "253.884px 179.23px"
    },
    id: "elerifhu8g0pd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,151.49c-.76-2.2-5-.67-5.11,1.18,1.81,2.86,4.52,10.84,3.31,16.75-1.8,8.77-6.54,13.14-16,20.39-6.38,4.87-10.17,8.57-13.14,18.84l4.2,12,13.62-7.33c1.76-4.83,4.81-9,10.38-15.84,8.08-10,9.64-17.65,9.5-24.71A38.16,38.16,0,0,0,266.33,151.49Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "254.244px 185.527px"
    },
    id: "elwn2k61o0w4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,146.7c-6.71-1.29-13-6-14.39-7.63l4.39-3.13c4,5,11.19,8.83,13.66,9.14Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "251.635px 141.32px"
    },
    id: "el5mv8gwbx0qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.44,144a13.46,13.46,0,0,0,2.05-7.9l-2.87-2.3s-.2,6-1.57,9.69Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "266.28px 138.9px"
    },
    id: "eljter9s175mc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,146.7c2-4.78,7.81-4.33,9.41-2.75a11,11,0,0,1-.09,7.55c-.77-1.32-4.25.12-5.13,1.17C259.24,152,257.05,148.12,257,146.7Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "262.017px 147.764px"
    },
    id: "ele9y4lq6rv5t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljhg57dvzwia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.55,149.59c-1.8-.33-3-4.22-1.79-6A6,6,0,0,0,257,146.7c0,1.42,2.21,5.29,4.19,6,.88-1,4.36-2.49,5.13-1.17a9.52,9.52,0,0,0,.38-1.14C265.58,147.69,263.35,149.92,261.55,149.59Z",
    style: {
      opacity: 0.2,
      transformOrigin: "261.85px 148.145px"
    },
    className: "animable",
    id: "eluawsr93h3wk"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-8",
    className: "animable",
    style: {
      transformOrigin: "250.324px 101.71px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.77,109.76c4-7.37,11.37-13.52,8.84-22.7,4.7.47,9-5.45,5.07-9,4.9-1.42,3.67-10.2-1.57-9.2.61-2.95-1.18-8.47-4.89-7.66-4,4-5.93,3.48-16.31,3.22-17.15-.44-25.13,4.85-23.71,18-3.06,1.9-4.73,9.6-1.78,16.19,4.42,10.54,10,9.48,13.53,18.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.324px 89.2849px"
    },
    id: "el1x058pync46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.54,117.51c-2.27,1.55-4.23,2.12-9.05,3.47l.07,2.82c.43,3,.33,3.73,1.74,5.21,2.59,4,1,7.18-2,13.29-8.9-9-15.74-4.22-22.79-14.39,1.07-1,.93-2.31.81-5.82l-1.08-13.27s0,1.26-2.52,1.74a7,7,0,0,1-6.31-2.51c-3.22-4.18-3.79-7.29-2-10.65,1.61-3.06,5.32-3.86,7.58-2.33,2.42,1.64,2.46,2.92,3.33,4.69s4,2,3.39-5.08c4.54-.85,5.43-8.08,4.17-14.34,4-3.46,12.44-5.76,19-4,2.7.72,5.09,1.92,6.59,6.7a21.17,21.17,0,0,1,1,5.85c.12,1.95,1.18,3.44,1.78,6.22a46.56,46.56,0,0,1,.69,8.72C275.07,112,273,115.84,270.54,117.51Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "250.676px 109.017px"
    },
    id: "el3ufvhgz7puo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.26,85.14l-4.33,2.56a2.42,2.42,0,0,1,.8-3.42A2.64,2.64,0,0,1,270.26,85.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.896px 85.8156px"
    },
    id: "eltsbb6p7zk7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.33,89.39,250,89a2.58,2.58,0,0,1,2.79-2.51A2.83,2.83,0,0,1,255.33,89.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.666px 87.9357px"
    },
    id: "elxpefoyhr9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.85,93.24a1.75,1.75,0,0,1-1.46,2.2,2,2,0,0,1-2.54-1.23,2.06,2.06,0,1,1,4-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.851px 93.5989px"
    },
    id: "elvhz8ch4lm0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.73,91.38a1.86,1.86,0,0,1-2,1.91,1.88,1.88,0,0,1-2.15-1.73,2.06,2.06,0,1,1,4.11-.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "268.65px 91.3043px"
    },
    id: "elscadkv1e14",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.45,90.15l2.47,12.13L269,98.82C266.29,93.62,261.92,89.61,259.45,90.15Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "264.225px 96.1906px"
    },
    id: "elb7qyuaqts99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.92,102.28l6.66-1.22s1.54-2.89-.48-2.49S261.92,102.28,261.92,102.28Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "265.531px 100.406px"
    },
    id: "elhg5eicp9pbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsevu1ev1fs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.92,102.28l6.66-1.22s1.54-2.89-.48-2.49S261.92,102.28,261.92,102.28Z",
    style: {
      opacity: 0.2,
      transformOrigin: "265.531px 100.406px"
    },
    className: "animable",
    id: "ela3pvqj44f0o"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.78,105.77a5.38,5.38,0,0,0-1.39-.5,3.76,3.76,0,0,0-2.94.32c-.08.06-.14.34,0,.36.51.06,1,0,1.54,0a10.31,10.31,0,0,1,1.45.2,7.37,7.37,0,0,1,1.29.47c.33.14.7.47,1.08.39.08,0,.11-.15.09-.22A2.17,2.17,0,0,0,260.78,105.77Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "259.136px 106.065px"
    },
    id: "elr5qao3oohwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfihrn857a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.78,105.77a5.38,5.38,0,0,0-1.39-.5,3.76,3.76,0,0,0-2.94.32c-.08.06-.14.34,0,.36.51.06,1,0,1.54,0a10.31,10.31,0,0,1,1.45.2,7.37,7.37,0,0,1,1.29.47c.33.14.7.47,1.08.39.08,0,.11-.15.09-.22A2.17,2.17,0,0,0,260.78,105.77Z",
    style: {
      opacity: 0.2,
      transformOrigin: "259.136px 106.065px"
    },
    className: "animable",
    id: "el9696b1fseen"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.17,117c-5.48,1-9.15,2.68-14.94,2.36-5.43-.29-7.45-3.85-9.09-6.32,1.87,4,3.16,5.65,4.61,6.55,3.21,2,6.41,2.82,14.74,1.36,4.33-1.22,5.75-1.49,7.95-2.81C270.62,117.49,269.14,116.48,266.17,117Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "255.993px 117.366px"
    },
    id: "elozk7jdsti4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,142.51c-2.33-1.34-4.95-4.27-8.32-2-3.13,2.09-5.19,5.85-6.86,5.4s-8-4.65-10.65-8.78-2.74-6.84-2.74-6.84a22,22,0,0,0,4-4.9c.89-1.87,1.14-3.15,2.59-3.29l.14,4.46a40.33,40.33,0,0,0,5.84,5.16C249.45,134.48,258.19,136.15,261.32,142.51Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "247.035px 134.024px"
    },
    id: "elk6pdb2tvl6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,142.51c1.33-1.27,2.47-3.64,3.83-3.94,2.25-.51,5.55,5.57,5.58,4.38s-1.61-9.63-3.36-12.1-4.29-7.18-5.81-7l.18,2.58a9.13,9.13,0,0,0,.59,2.68,12.15,12.15,0,0,1,.69,5.21C262.89,136.3,261.55,140.56,261.32,142.51Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "266.025px 133.475px"
    },
    id: "elh7jzh3a8yra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.39,226c.18,10.79.67,13.37-.35,17.7a41.15,41.15,0,0,0-1.2,14.86c.81,8.52,1.06,10.81,2.64,13.24a11.63,11.63,0,0,0,2.81,2.85,2.75,2.75,0,0,0,2.92,2.12c.73,2.89,2.7,3.76,4,3.56,1.15,3.29,2,3.68,2.64,3.16a6.5,6.5,0,0,0,2.29-4.92c-.05-3.11-1.29-7-1.78-9.91-.82-5-1.81-10-1-10.08s1,4.79,2.8,7.68c2.36,3.74,5.56,2,5.27.76a30.55,30.55,0,0,1-1.25-8.55c-.29-8.94-2.61-8.81-3.29-15.1-.72-6.75-.18-24.51-.18-24.51Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "198.038px 251.27px"
    },
    id: "el2o9lhutkrhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.71,132.81c-14.59,2.95-16,9.12-19.86,17.8A285.83,285.83,0,0,0,192,179.47c-2.68,8.18-3.6,11.19-3.86,20.75-.4,14.77,0,35.31,0,35.31,5.72,1.95,11.42,2.72,17.08.53l5.91-40,14.72-31.9S233.47,143.56,222.71,132.81Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "208.215px 185.097px"
    },
    id: "elflqdpfwgra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,229.09l.17,7.34s.46,2.1,8,2.73,9.29-1.52,9.29-1.52l.7-7.19s-2.06,1.64-9.3,1.25C189.72,231.31,188,229.09,188,229.09Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.08px 234.183px"
    },
    id: "elq8wejjse7fp",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorysetStandOut31397);
export default __webpack_public_path__ + "static/media/storyset_stand_out_31397.5a2fdec34cb027dbc869017b986f0a50.svg";
export { ForwardRef as ReactComponent };